import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { contentService, approvalService, draftsService, statsService, revisionService } from "../../services/firestoreService";
import { auth } from "../../firebase";
import { doc, getDoc, collection, onSnapshot, query, orderBy, where, limit } from "firebase/firestore";
import { useLanguage } from "../../contexts/LanguageContext";
import {
  FiPlus,
  FiCalendar,
  FiBold,
  FiItalic,
  FiUnderline,
  FiType,
  FiList,
  FiLink,
  FiImage,
  FiVideo,
  FiMoreHorizontal,
  FiFileText,
  FiAlignLeft,
  FiAlignCenter,
  FiAlignRight,
  FiAlignJustify,
  FiPackage,
  FiArrowLeft,
  FiRotateCcw,
  FiRotateCw,
  FiCode,
  FiX,
  FiChevronDown,
  FiMinus,
  FiVolume2,
  FiUpload,
  FiEdit,
  FiEye,
  FiTrendingUp,
  FiClock,
  FiCheckCircle,
  FiBell,
  FiUsers,
  FiBarChart2,
  FiBookmark,
  FiLayers,
  FiMoreVertical,
  FiShare2,
  FiEye as FiView,
  FiSave
} from "react-icons/fi";
import { RiShare2Line } from "react-icons/ri";
import { FaFacebook, FaXTwitter, FaWhatsapp, FaTelegram } from "react-icons/fa6";
import Portal from "../../components/Portal";
import "./staffcss/contentdashboard.css";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from "recharts";

// Optional: import your chart image when available
// import engagementChart from "../../images/engagementchart.png";

const ContentDashboard = ({ showAddContent = false, onBack, editingDraft, onCreateNew, onEditDraft, isAnnouncementMode = false }) => {
  const { getTranslations } = useLanguage();
  const t = getTranslations(false, true);
  const navigate = useNavigate();
  const [view, setView] = useState("dashboard"); // 'dashboard' | 'add-content' | 'publish-event'
  const [currentUserId, setCurrentUserId] = useState(null);
  const [currentUserEmail, setCurrentUserEmail] = useState(null);
  const [content, setContent] = useState("");
  const [characterCount, setCharacterCount] = useState(0);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [tags, setTags] = useState([]);
  const [currentTag, setCurrentTag] = useState("");
  const [isSaved, setIsSaved] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [initialContent, setInitialContent] = useState({ title: '', subtitle: '', content: '', tags: [] });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [history, setHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [selectedStyle, setSelectedStyle] = useState("Normal text");
  const [embedBar, setEmbedBar] = useState(null); // { type, url, text, cursorOffset }
  const [alignment, setAlignment] = useState("left");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewDevice, setPreviewDevice] = useState("desktop"); // 'mobile' | 'desktop'
  const [isPublishOpen, setIsPublishOpen] = useState(false);
  const [publishCategory, setPublishCategory] = useState("");
  const [isAnnouncement, setIsAnnouncement] = useState(isAnnouncementMode);
  const [minorEligible, setMinorEligible] = useState(false);
  const [isEditSocialOpen, setIsEditSocialOpen] = useState(false);
  const [socialTitle, setSocialTitle] = useState("");
  const [socialDescription, setSocialDescription] = useState("");
  const [socialImageUrl, setSocialImageUrl] = useState("");
  const [contentId, setContentId] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [validationModal, setValidationModal] = useState({ show: false, message: "" });
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [dailyStats, setDailyStats] = useState([]);
  const [loadingDailyStats, setLoadingDailyStats] = useState(true);
  const [analyticsData, setAnalyticsData] = useState({
    content: { draft: 0, pending: 0, published: 0, total: 0 },
    announcements: { draft: 0, pending: 0, published: 0, total: 0 },
    engagement: { totalViews: 0, totalBookmarks: 0, totalShares: 0 }
  });
  const [loadingAnalytics, setLoadingAnalytics] = useState(true);
  
  // Cache duration for daily analytics (5 minutes)
  const CACHE_DURATION = 5 * 60 * 1000;
  const [latestPost, setLatestPost] = useState(null);
  const [loadingLatestPost, setLoadingLatestPost] = useState(true);
  const [latestPostRevision, setLatestPostRevision] = useState(null);
  const [drafts, setDrafts] = useState([]);
  const [loadingDrafts, setLoadingDrafts] = useState(true);
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [loadingPendingApprovals, setLoadingPendingApprovals] = useState(true);
  const [topPerformingContent, setTopPerformingContent] = useState([]);
  const [loadingTopPerforming, setLoadingTopPerforming] = useState(true);
  const [mostViewedCategory, setMostViewedCategory] = useState(null);
  const [topEngagementCategories, setTopEngagementCategories] = useState([]);
  const [loadingAudienceInsights, setLoadingAudienceInsights] = useState(true);
  const [openPendingDropdownId, setOpenPendingDropdownId] = useState(null);
  const [shareModal, setShareModal] = useState(false);
  const [copyButtonText, setCopyButtonText] = useState("Copy Link");
  const [isOptionsDropdownOpen, setIsOptionsDropdownOpen] = useState(false);
  const [openDraftDropdownId, setOpenDraftDropdownId] = useState(null);
  const [showCopiedBanner, setShowCopiedBanner] = useState(false);
  const [deleteDraftModal, setDeleteDraftModal] = useState(false);
  const [draftToDelete, setDraftToDelete] = useState(null);
  const [currentUserFirstName, setCurrentUserFirstName] = useState("");
  const optionsDropdownRef = useRef(null);
  const autosaveTimerRef = useRef(null);
  const editorRef = useRef(null);
  const cursorRestoreRef = useRef(null);
  const contentUpdateSourceRef = useRef(null); // 'user' | 'programmatic' – only replace editor DOM when programmatic
  const importFileInputRef = useRef(null);
  const socialImageInputRef = useRef(null);
  const dailyAnalyticsCache = useRef({
    data: null,
    timestamp: null,
    userId: null
  });
  
  // Local cache for latest post revision to prevent redundant service calls
  const revisionCache = useRef({
    contentId: null,
    data: null,
    timestamp: null
  });
  const REVISION_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  // Fetch user first name
  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      const fetchUserDoc = async () => {
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            const fullName = userData.fullName || userData.name || "";
            const firstName = fullName.trim().split(" ")[0];
            setCurrentUserFirstName(firstName);
          } else if (user.displayName) {
            const firstName = user.displayName.trim().split(" ")[0];
            setCurrentUserFirstName(firstName);
          }
        } catch (err) {
          console.error("Error fetching user doc:", err);
        }
      };
      fetchUserDoc();
    }
  }, [auth.currentUser]);

  // Auth state listener
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUserId(user ? user.uid : null);
      setCurrentUserEmail(user ? user.email : null);
    });
    return () => unsubscribe();
  }, []);

  // Close options dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if clicking inside latest post dropdown before closing
      const isInsideLatestPostDropdown = event.target.closest('.latest-post-dropdown-container');
      if (!isInsideLatestPostDropdown) {
        setIsOptionsDropdownOpen(false);
      }
      
      // Check if clicking inside draft dropdown before closing
      const isInsideDraftDropdown = event.target.closest('.draft-dropdown-container');
      if (!isInsideDraftDropdown) {
        setOpenDraftDropdownId(null);
      }
      
      // Check if clicking inside pending dropdown before closing
      const isInsidePendingDropdown = event.target.closest('.pending-dropdown-container');
      if (!isInsidePendingDropdown) {
        setOpenPendingDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fetch daily engagement analytics with caching
  useEffect(() => {
    const fetchDailyStats = async () => {
      try {
        const now = Date.now();
        const cache = dailyAnalyticsCache.current;
        
        // Check if we have valid cached data for this user
        if (cache.data && 
            cache.userId === currentUserId && 
            cache.timestamp && 
            (now - cache.timestamp) < CACHE_DURATION) {
          setDailyStats(cache.data);
          setLoadingDailyStats(false);
          return;
        }
        
        // Fetch fresh data if cache is invalid or expired
        const stats = await statsService.getDailyAnalytics(7, currentUserId);
        setDailyStats(stats);
        setLoadingDailyStats(false);
        
        // Update cache
        dailyAnalyticsCache.current = {
          data: stats,
          timestamp: now,
          userId: currentUserId
        };
      } catch (error) {
        console.error("Error fetching daily stats:", error);
        setLoadingDailyStats(false);
      }
    };

    if (view === "dashboard" && currentUserId) {
      setLoadingDailyStats(true);
      fetchDailyStats();
    }
  }, [view, currentUserId]);

  // Fetch analytics data, latest post, and drafts - OPTIMIZED
  useEffect(() => {
    if (view !== "dashboard" || !currentUserId) {
      setLatestPost(null);
      setDrafts([]);
      setAnalyticsData({
        content: { draft: 0, pending: 0, published: 0, total: 0 },
        announcements: { draft: 0, pending: 0, published: 0, total: 0 },
        engagement: { totalViews: 0, totalBookmarks: 0, totalShares: 0 }
      });
      setLoadingAnalytics(false);
      setLoadingDrafts(false);
      setLoadingPendingApprovals(false);
      setLoadingLatestPost(false);
      setLoadingTopPerforming(false);
      setLoadingAudienceInsights(false);
      return;
    }

    setLoadingAnalytics(true);
    setLoadingDrafts(true);
    setLoadingPendingApprovals(true);
    setLoadingLatestPost(true);
    setLoadingTopPerforming(true);
    setLoadingAudienceInsights(true);
    let mounted = true;

    // State to hold drafts from both collections
    let allDraftItems = [];
    let allPendingItems = [];
    let contentCounts = { draft: 0, pending: 0, published: 0, total: 0 };
    let announcementCounts = { draft: 0, pending: 0, published: 0, total: 0 };

    // Function to update state with combined drafts and counts
    const updateState = () => {
      if (!mounted) return;
      
      // Make copies of counts to modify
      const updatedContentCounts = { ...contentCounts };
      const updatedAnnouncementCounts = { ...announcementCounts };
      
      // Add drafts from drafts collection to counts
      allDraftItems.filter(d => d.source === 'drafts').forEach(draft => {
        // Check if it's an announcement (category)
        const isAnnouncement = draft.category === "Community Outreach Programs";
        const counts = isAnnouncement ? updatedAnnouncementCounts : updatedContentCounts;
        counts.draft++;
        counts.total++;
      });

      // Sort drafts by lastModified descending
      allDraftItems.sort((a, b) => {
        const dateA = a.lastModified?.toDate ? a.lastModified.toDate() : new Date(a.lastModified);
        const dateB = b.lastModified?.toDate ? b.lastModified.toDate() : new Date(b.lastModified);
        return dateB - dateA;
      });

      // Sort pending items by submittedAt descending
      allPendingItems.sort((a, b) => {
        const dateA = a.submittedAt?.toDate ? a.submittedAt.toDate() : new Date(a.submittedAt);
        const dateB = b.submittedAt?.toDate ? b.submittedAt.toDate() : new Date(b.submittedAt);
        return dateB - dateA;
      });

      // Set drafts and pending states
      setDrafts(allDraftItems.slice(0, 3));
      setLoadingDrafts(false);
      setPendingApprovals(allPendingItems.slice(0, 3));
      setLoadingPendingApprovals(false);

      // Update analytics state
      setAnalyticsData(prev => ({
        ...prev,
        content: updatedContentCounts,
        announcements: updatedAnnouncementCounts
      }));
      setLoadingAnalytics(false);
    };

    // Listener for approvals collection (content and announcements) with server-side filtering - OPTIMIZED
    const approvalsQuery = query(
      collection(db, "approvals"),
      where("authorId", "==", currentUserId),
      limit(50) // Add limit
    );
    
    const unsubscribeApprovals = onSnapshot(approvalsQuery, (snapshot) => {
      if (!mounted) return;
      
      // Reset counts
      contentCounts = { draft: 0, pending: 0, published: 0, total: 0 };
      announcementCounts = { draft: 0, pending: 0, published: 0, total: 0 };
      
      // Keep drafts from drafts collection
      const draftsFromDraftsCollection = allDraftItems.filter(d => d.source === 'drafts');
      allDraftItems = [...draftsFromDraftsCollection];
      allPendingItems = [];

      snapshot.docs.forEach(doc => {
        const data = { id: doc.id, ...doc.data() };
        const isAnnouncement = data.category === "Community Outreach Programs";
        const counts = isAnnouncement ? announcementCounts : contentCounts;

        // Determine status
        if (data.status === "draft" || !data.status) {
          counts.draft++;
          allDraftItems.push({
            ...data,
            id: data.id,
            source: 'approvals'
          });
        } else if (data.status === "Pending") {
          counts.pending++;
          allPendingItems.push(data);
        } else if (data.status === "Approved") {
          counts.published++;
        }

        counts.total++;
      });

      updateState();
    }, (error) => {
      console.error("Error in approvals listener:", error);
    });

    // Listener for drafts collection with limit to prevent excessive reads - OPTIMIZED
    const draftsQuery = query(
      collection(db, "drafts"),
      where("authorId", "==", currentUserId),
      orderBy("updatedAt", "desc"),
      limit(20)
    );
    
    const unsubscribeDrafts = onSnapshot(draftsQuery, (snapshot) => {
      if (!mounted) return;
      
      // Keep drafts from approvals collection
      const draftsFromApprovalsCollection = allDraftItems.filter(d => d.source === 'approvals');
      allDraftItems = [...draftsFromApprovalsCollection];

      snapshot.docs.forEach(doc => {
        const data = { id: doc.id, ...doc.data() };
        allDraftItems.push({
          ...data,
          id: data.id,
          source: 'drafts'
        });
      });

      updateState();
    }, (error) => {
      console.error("Error in drafts listener:", error);
    });

    // Listener for published collection (engagement metrics and latest post) with server-side filtering - OPTIMIZED
    const publishedQuery = query(
      collection(db, "published"),
      where("authorId", "==", currentUserId),
      orderBy("publishedAt", "desc"),
      limit(50)
    );
    
    const unsubscribePublished = onSnapshot(publishedQuery, (snapshot) => {
      if (!mounted) return;
      let totalViews = 0;
      let totalBookmarks = 0;
      let totalShares = 0;
      let latestPublishedPost = null;
      let userPublishedItems = [];
      let categoryViews = {};
      let categoryEngagement = {};

      const userPublishedDocs = snapshot.docs;

      if (userPublishedDocs.length === 0) {
        setLatestPost(null);
        setLoadingLatestPost(false);
        setTopPerformingContent([]);
        setLoadingTopPerforming(false);
        setMostViewedCategory(null);
        setTopEngagementCategories([]);
        setLoadingAudienceInsights(false);
      } else {
        const firstDoc = userPublishedDocs[0];
        latestPublishedPost = { id: firstDoc.id, ...firstDoc.data() };
        setLatestPost(latestPublishedPost);
        setLoadingLatestPost(false);

        // Calculate top performing content and category stats
        userPublishedDocs.forEach(doc => {
          const data = { id: doc.id, ...doc.data() };
          const stats = data.stats || { views: 0, shares: 0, bookmarks: 0 };
          const total = (stats.views || 0) + (stats.bookmarks || 0) + (stats.shares || 0);
          userPublishedItems.push({
            ...data,
            totalEngagement: total,
            views: stats.views || 0,
            bookmarks: stats.bookmarks || 0,
            shares: stats.shares || 0
          });

          // Aggregate by category
          const category = data.category || "Uncategorized";
          if (!categoryViews[category]) {
            categoryViews[category] = 0;
          }
          categoryViews[category] += stats.views || 0;

          if (!categoryEngagement[category]) {
            categoryEngagement[category] = 0;
          }
          categoryEngagement[category] += total;
        });

        // Sort by totalEngagement descending
        userPublishedItems.sort((a, b) => b.totalEngagement - a.totalEngagement);
        // Take top 3
        setTopPerformingContent(userPublishedItems.slice(0, 3));
        setLoadingTopPerforming(false);

        // Find most viewed category
        let maxViews = -1;
        let mostViewed = null;
        for (const [cat, views] of Object.entries(categoryViews)) {
          if (views > maxViews) {
            maxViews = views;
            mostViewed = cat;
          }
        }
        setMostViewedCategory(mostViewed);

        // Find top engagement categories
        const categoryEngagementArray = Object.entries(categoryEngagement)
          .map(([category, total]) => ({ category, total }))
          .sort((a, b) => b.total - a.total)
          .slice(0, 3);
        setTopEngagementCategories(categoryEngagementArray);
        setLoadingAudienceInsights(false);
      }

      userPublishedDocs.forEach(doc => {
        const data = doc.data();
        const stats = data.stats || { views: 0, shares: 0, bookmarks: 0 };
        totalViews += stats.views || 0;
        totalBookmarks += stats.bookmarks || 0;
        totalShares += stats.shares || 0;
      });

      // Update analytics state
      setAnalyticsData(prev => ({
        ...prev,
        engagement: { totalViews, totalBookmarks, totalShares }
      }));
    }, (error) => {
      console.error("Error in published listener:", error);
    });

    // Cleanup listeners with mounted flag
    return () => {
      mounted = false;
      unsubscribeApprovals();
      unsubscribeDrafts();
      unsubscribePublished();
    };
  }, [view, currentUserId]);

  const PUBLISH_CATEGORIES = [
    "Menstrual Wellness and Hygiene",
    "Contraception",
    "Fertility Basics",
    "STI Awareness",
    "Mental Health in Reproductive Care",
    "Male Reproductive Health",
    "Pregnancy Prevention",
    "General Reproductive Wellness",
    "Community Outreach Programs"
  ];

  const stripHtmlToText = (html) => {
    try {
      const div = document.createElement("div");
      div.innerHTML = html || "";
      return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
    } catch {
      return "";
    }
  };

  const calculateCharacterCount = (html) => {
    return stripHtmlToText(html).length;
  };

  // Helper to format date for latest post (Month DD, YYYY)
  const formatPostDate = (dateValue) => {
    if (!dateValue) return "";
    let date;
    if (dateValue.toDate && typeof dateValue.toDate === "function") {
      date = dateValue.toDate();
    } else if (dateValue instanceof Date) {
      date = dateValue;
    } else {
      date = new Date(dateValue);
    }
    if (isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", { month: "long", day: "2-digit", year: "numeric" });
  };

  // Helper to format draft last modified date (Month DD, YYYY HH:MM AM/PM)
  const formatDraftDate = (dateValue) => {
    if (!dateValue) return "";
    let date;
    if (dateValue.toDate && typeof dateValue.toDate === "function") {
      date = dateValue.toDate();
    } else if (dateValue instanceof Date) {
      date = dateValue;
    } else {
      date = new Date(dateValue);
    }
    if (isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  // Fetch revision for latest post with local caching
  useEffect(() => {
    const fetchRevision = async () => {
      if (latestPost && latestPost.contentId) {
        try {
          const contentId = latestPost.contentId;
          const now = Date.now();
          const cache = revisionCache.current;
          
          // Check if we have valid cached data for this contentId
          if (cache.contentId === contentId && 
              cache.data && 
              cache.timestamp && 
              (now - cache.timestamp) < REVISION_CACHE_DURATION) {
            setLatestPostRevision(cache.data);
            return;
          }
          
          // Fetch fresh data if cache is invalid or expired
          const revision = await revisionService.getRevisionByContentId(contentId);
          setLatestPostRevision(revision);
          
          // Update local cache
          revisionCache.current = {
            contentId: contentId,
            data: revision,
            timestamp: now
          };
        } catch (err) {
          console.error("Error fetching latest post revision:", err);
          setLatestPostRevision(null);
        }
      } else {
        setLatestPostRevision(null);
      }
    };
    fetchRevision();
  }, [latestPost]);

  // Share functionality
  const getArticleUrl = () => {
    if (!latestPost) return "";
    return `https://auravit-cfsi.com/learn/article/${latestPost.contentId || latestPost.id}`;
  };

  // Copy link with banner
  const handleCopyLatestPostLink = async () => {
    const url = getArticleUrl();
    try {
      await navigator.clipboard.writeText(url);
      setShowCopiedBanner(true);
      setIsOptionsDropdownOpen(false);
      setTimeout(() => setShowCopiedBanner(false), 3000);
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };

  // Delete draft
  const handleDeleteDraft = async () => {
    if (!draftToDelete) return;
    try {
      await draftsService.deleteDraft(draftToDelete.id);
      setDeleteDraftModal(false);
      setDraftToDelete(null);
    } catch (err) {
      console.error("Error deleting draft:", err);
    }
  };

  const handleShare = async () => {
    setShareModal(true);
    setCopyButtonText("Copy Link");
  };

  const handleCloseShareModal = () => {
    setShareModal(false);
  };

  const handleCopyLink = async () => {
    const url = getArticleUrl();
    try {
      await navigator.clipboard.writeText(url);
      setCopyButtonText("Copied!");
      setTimeout(() => setCopyButtonText("Copy Link"), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  const handleSocialShare = (platform) => {
    const articleUrl = getArticleUrl();
    const url = encodeURIComponent(articleUrl);
    const title = encodeURIComponent(latestPost?.title || "");
    const description = encodeURIComponent(latestPost?.socialDescription || latestPost?.subtitle || "");

    let shareUrl = "";

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
        break;
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${title}%20${url}`;
        break;
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${url}&text=${title}`;
        break;
      default:
        return;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank", "noopener,noreferrer");
    }
  };

  const openPublishModal = () => {
    // Default social preview fields from editor state
    const bodyText = stripHtmlToText(content);
    setSocialTitle((title || "").trim());
    setSocialDescription(
      ((subtitle || "").trim() || bodyText).slice(0, 160)
    );
    setIsPublishOpen(true);
  };

  const createDraftIfNeeded = async () => {
    if (contentId) return contentId;

    const newContent = await contentService.createContent({
      title,
      subtitle,
      category: publishCategory || "",
      bodyHtml: content,
      socialTitle,
      socialDescription,
      socialImageUrl,
      minorEligible,
      status: "Draft",
    });

    const id = newContent.id;
    if (id) setContentId(id);
    return id;
  };

  const saveDraft = async () => {
    if (!contentId) return;
    await contentService.updateContent(contentId, {
      title,
      subtitle,
      category: publishCategory || "",
      bodyHtml: content,
      socialTitle,
      socialDescription,
      socialImageUrl,
      minorEligible,
      status: "Draft",
    });
  };

  const publishContent = async () => {
    try {
      const id = await createDraftIfNeeded();
      if (!id) {
        alert("Could not save draft. Please try again.");
        return;
      }
      await contentService.updateContent(id, {
        title,
        subtitle,
        category: publishCategory || "",
        bodyHtml: content,
        socialTitle,
        socialDescription,
        socialImageUrl,
        minorEligible,
        status: "Published",
      });
      closePublishModal();
      alert("Content published!");
    } catch (err) {
      const msg = err.message || "Publish failed. Please try again.";
      alert(msg);
    }
  };

  const submitForApproval = async () => {
    // Validate required fields
    if (!title.trim()) {
      setValidationModal({ show: true, message: "Please enter a title before submitting for approval." });
      return;
    }
    if (!content.trim() || content === "<br>") {
      setValidationModal({ show: true, message: "Please add content before submitting for approval." });
      return;
    }
    if (!publishCategory) {
      setValidationModal({ show: true, message: "Please select a category before submitting for approval." });
      return;
    }

    try {
      setIsSubmitting(true);
      // Get current user information from Firebase auth and Firestore
      const authUser = auth.currentUser;
      if (!authUser) {
        console.error('No user logged in');
        return;
      }

      // Fetch user data from Firestore to get full name
      const userDoc = await getDoc(doc(db, 'users', authUser.uid));
      const userData = userDoc.exists() ? userDoc.data() : {};

      // Always generate a unique contentId for each submission
      const finalContentId = `content_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      
      // Create the approval data object with all article content
      const approvalData = {
        title: title.trim(),
        subtitle: subtitle.trim(),
        category: publishCategory,
        bodyHtml: content,
        socialTitle: socialTitle.trim(),
        socialDescription: socialDescription.trim(),
        socialImageUrl: socialImageUrl.trim(),
        minorEligible,
        tags: tags,
        contentId: finalContentId, // Ensure contentId is never empty
        author: userData.fullName || "Unknown", // Use full name from Firestore user document
        authorId: authUser.uid, // Add Firebase auth UID for isolation
        authorEmail: userData.email || authUser.email || "",
        authorRole: userData.role || "",
        submittedAt: new Date().toISOString(),
      };

      // Submit to approval collection
      await approvalService.submitForApproval(approvalData);

      // If we're editing an existing draft, delete it from drafts collection
      if (contentId) {
        try {
          await draftsService.deleteDraft(contentId);
        } catch (deleteError) {
          console.error('ContentDashboard: Error deleting draft from drafts collection:', deleteError);
          // Continue with submission even if draft deletion fails
        }
      }
      
      closePublishModal();
      setShowSuccessModal(true);
      
    } catch (err) {
      const msg = err.message || "Submission failed. Please try again.";
      alert(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  const closePublishModal = () => {
    setIsPublishOpen(false);
    setIsEditSocialOpen(false);
  };

  const openEditSocial = () => {
    setIsEditSocialOpen(true);
  };

  const closeEditSocial = () => {
    setIsEditSocialOpen(false);
  };

  const handlePickSocialImage = (e) => {
    const file = e.target.files[0];
    if (!file.type?.startsWith("image/")) return;
    
    // Check file size (limit to ~500KB to ensure base64 stays under Firestore limit)
    const maxSizeInBytes = 500 * 1024; // 500KB
    if (file.size > maxSizeInBytes) {
      alert(`Image is too large. Please choose an image smaller than 500KB. Selected file: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
      e.target.value = "";
      return;
    }
    
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = String(reader.result || "");
      
      // Additional check for base64 string length (Firestore has ~1MB limit)
      const estimatedSizeInBytes = Math.round(base64String.length * 0.75); // Rough estimate
      if (estimatedSizeInBytes > 1024 * 1024) { // 1MB
        alert(`Image is still too large after encoding. Please choose a smaller image or compress it first.`);
        e.target.value = "";
        return;
      }
      
      setSocialImageUrl(base64String);
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  // Get caret character offset from the start of the editor element (element must be a DOM Node)
  const getCaretCharacterOffsetWithin = (element) => {
    if (!element || typeof element.nodeType !== "number") return { start: 0, end: 0 };
    const selection = window.getSelection();
    if (!selection.rangeCount) return { start: 0, end: 0 };
    const range = selection.getRangeAt(0);
    try {
      const preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(element);
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      const end = preCaretRange.toString().length;
      preCaretRange.setEnd(range.startContainer, range.startOffset);
      const start = preCaretRange.toString().length;
      return { start, end };
    } catch (err) {
      return { start: 0, end: 0 };
    }
  };

  // Set caret at character offset within the editor element (element must be a DOM Node)
  const setCaretPosition = (element, startOffset, endOffset) => {
    if (!element || typeof element.nodeType !== "number") return;
    const selection = window.getSelection();
    const range = document.createRange();
    let charCount = 0;
    let startNode = null, startOffsetInNode = 0, endNode = null, endOffsetInNode = 0;

    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const nextCount = charCount + node.length;
        if (startNode === null && startOffset <= nextCount) {
          startNode = node;
          startOffsetInNode = startOffset - charCount;
        }
        if (endNode === null && endOffset <= nextCount) {
          endNode = node;
          endOffsetInNode = endOffset - charCount;
        }
        charCount = nextCount;
      } else {
        for (let i = 0; i < node.childNodes.length; i++) {
          walk(node.childNodes[i]);
          if (startNode !== null && endNode !== null) return;
        }
      }
    };
    walk(element);
    if (startNode === null) {
      startNode = element;
      startOffsetInNode = element.childNodes.length;
    }
    if (endNode === null) {
      endNode = element;
      endOffsetInNode = element.childNodes.length;
    }
    try {
      range.setStart(startNode, startOffsetInNode);
      range.setEnd(endNode, endOffsetInNode);
      selection.removeAllRanges();
      selection.addRange(range);
    } catch (e) {
      try {
        range.selectNodeContents(element);
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
      } catch (e2) {
        // ignore if element is detached
      }
    }
  };

  // Save content to history for undo/redo
  const saveToHistory = () => {
    const newHistory = history.slice(0, historyIndex + 1);
    newHistory.push(content);
    setHistory(newHistory);
    setHistoryIndex(newHistory.length - 1);
  };

  // Handle content change (e.target may be editor itself or a nested node like figcaption)
  // options.preserveCursor: when true, do not clear cursorRestoreRef (used after insertHTMLAtCursor)
  const handleContentChange = (e, options) => {
    const el = e.target;
    const editor = editorRef.current;
    let newContent = editor && editor.innerHTML !== undefined ? editor.innerHTML : "";
    
    // Calculate character count by stripping HTML tags
    let count = calculateCharacterCount(newContent);
    
    // Enforce 5000 character limit
    if (count > 5000) {
      // Truncate content to 5000 characters
      let truncated = "";
      let tempLength = 0;
      const div = document.createElement("div");
      div.innerHTML = newContent;
      
      const truncateNode = (node) => {
        if (tempLength >= 5000) return;
        
        if (node.nodeType === Node.TEXT_NODE) {
          const remaining = 5000 - tempLength;
          if (node.length <= remaining) {
            truncated += node.textContent;
            tempLength += node.length;
          } else {
            truncated += node.textContent.substring(0, remaining);
            tempLength = 5000;
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const tag = node.tagName.toLowerCase();
          truncated += `<${tag}>`;
          for (let i = 0; i < node.childNodes.length; i++) {
            truncateNode(node.childNodes[i]);
            if (tempLength >= 5000) break;
          }
          if (tempLength < 5000) {
            truncated += `</${tag}>`;
          }
        }
      };
      
      for (let i = 0; i < div.childNodes.length; i++) {
        truncateNode(div.childNodes[i]);
        if (tempLength >= 5000) break;
      }
      
      newContent = truncated;
      count = 5000;
      
      // Update editor DOM with truncated content
      if (editor) {
        contentUpdateSourceRef.current = "programmatic";
        editor.innerHTML = newContent;
        // Move cursor to end
        const range = document.createRange();
        range.selectNodeContents(editor);
        range.collapse(false);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
    
    const isUserInput =
      el && typeof el.nodeType === "number" && editor && editor.contains(el);

    if (isUserInput && editor) {
      // Treat any input coming from inside the editor as user typing; keep DOM as-is and just sync state.
      contentUpdateSourceRef.current = "user"; // do not replace editor DOM on next render - keeps cursor in place
      // Don't save cursor position for user input to allow natural cursor movement (including Enter key)
      editor.style.direction = "ltr";
      editor.style.unicodeBidi = "embed";
    } else if (!options?.preserveCursor) {
      cursorRestoreRef.current = null;
    }

    setContent(newContent);
    setCharacterCount(count);
    if (!isInitialLoad) {
      checkForChanges();
    } else {
      setIsInitialLoad(false);
      setInitialContent({ title, subtitle, content: newContent, tags });
    }
    saveToHistory();
  };

  // Check for changes in all fields
  const checkForChanges = () => {
    if (isInitialLoad) return;
    const hasChanges =
      title !== initialContent.title ||
      subtitle !== initialContent.subtitle ||
      content !== initialContent.content ||
      JSON.stringify(tags) !== JSON.stringify(initialContent.tags);
    setIsSaved(!hasChanges);
    setHasUnsavedChanges(hasChanges);
  };

  const handleBackClick = () => {
    if (hasUnsavedChanges) {
      setShowUnsavedModal(true);
    } else {
      onBack ? onBack() : setView("dashboard");
    }
  };

  const handleLeaveUnsaved = () => {
    setShowUnsavedModal(false);
    onBack ? onBack() : setView("dashboard");
  };

  const handleContinueEditing = () => {
    setShowUnsavedModal(false);
  };

  const handleSaveAndLeave = async () => {
    try {
      await handleSaveDraft();
      setShowUnsavedModal(false);
      onBack ? onBack() : setView("dashboard");
    } catch (error) {
      console.error('Error saving before leaving:', error);
      alert('Failed to save changes. Please try again.');
    }
  };

  // Undo functionality
  // Save draft functionality
  const handleSaveDraft = async () => {
    try {
      setIsSaving(true);
      const user = auth.currentUser;
      if (!user) {
        alert('Please log in to save drafts.');
        return;
      }
      const draftData = {
        title: title || 'Untitled Draft',
        subtitle: subtitle || '',
        bodyHtml: content || '',
        category: publishCategory || 'General Health',
        tags: tags || [],
        socialTitle: title || 'Untitled Draft',
        socialDescription: socialDescription || '',
        socialImageUrl: socialImageUrl || '',
        status: "draft",
      };

      // If we have an existing contentId, update existing draft
      if (contentId) {
        // Check if this draft exists in drafts collection
        const currentDraft = await draftsService.getDraftById(contentId);

        if (currentDraft) {
          // Update existing draft
          await draftsService.updateDraft(contentId, draftData);
        } else {
          // Draft doesn't exist in drafts collection, might be in approvals - create new draft
          const newDraft = await draftsService.createDraft(draftData);
          setContentId(newDraft.id);
        }
      } else {
        // Create new draft
        const newDraft = await draftsService.createDraft(draftData);
        setContentId(newDraft.id);
      }

      setIsSaved(true);
      setHasUnsavedChanges(false);
      setInitialContent({ title, subtitle, content, tags });

      // Trigger event to refresh ContentLibrary
      window.dispatchEvent(new CustomEvent('draftSaved'));
    } catch (error) {
      console.error('Error saving draft:', error);
      alert('Failed to save draft. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleUndo = () => {
    if (historyIndex > 0) {
      setHistoryIndex(historyIndex - 1);
      contentUpdateSourceRef.current = "programmatic";
      setContent(history[historyIndex - 1]);
      if (editorRef.current) {
        editorRef.current.innerHTML = history[historyIndex - 1];
      }
      checkForChanges();
    }
  };

  // Redo functionality
  const handleRedo = () => {
    if (historyIndex < history.length - 1) {
      setHistoryIndex(historyIndex + 1);
      contentUpdateSourceRef.current = "programmatic";
      setContent(history[historyIndex + 1]);
      if (editorRef.current) {
        editorRef.current.innerHTML = history[historyIndex + 1];
      }
      checkForChanges();
    }
  };

// Focus editor so toolbar commands apply to content
const focusEditor = () => {
editorRef.current?.focus();
};

// Text formatting functions – focus editor first so selection is used; allow natural cursor behavior
const execCommand = (command, value = null) => {
  const editor = editorRef.current;
  if (!editor) return;
  focusEditor();
  document.execCommand(command, false, value);
  contentUpdateSourceRef.current = "programmatic";
  cursorRestoreRef.current = getCaretCharacterOffsetWithin(editor);
  handleContentChange({ target: { innerHTML: editor.innerHTML } }, { preserveCursor: true });
};

// Insert HTML at cursor (for embeds); then sync content and allow natural cursor behavior
const insertHTMLAtCursor = (html) => {
  const editor = editorRef.current;
  if (!editor) return;
  focusEditor();
  document.execCommand("insertHTML", false, html);
  contentUpdateSourceRef.current = "programmatic";
  cursorRestoreRef.current = getCaretCharacterOffsetWithin(editor);
  handleContentChange({ target: { innerHTML: editor.innerHTML } }, { preserveCursor: true });
};

  // Delete button markup for embeds (media and link/comment)
  const embedRemoveButton = '<span class="cc-embed-remove" role="button" tabindex="-1" title="Remove" aria-label="Remove">&times;</span>';

  // Remove embed when delete button is clicked (event delegation); keep cursor near where embed was
  const handleEditorClick = (e) => {
    const editor = editorRef.current;
    if (!editor) return;
    const removeBtn = e.target.closest?.(".cc-embed-remove");
    if (!removeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    const embed = removeBtn.closest?.(".cc-embed");
    if (embed && editor.contains(embed)) {
      // Place cursor after embed's previous sibling (or at start) before removing, so it stays in place
      try {
        const sel = window.getSelection();
        const range = document.createRange();
        const prev = embed.previousSibling;
        if (prev) {
          range.setStartAfter(prev);
          range.collapse(true);
        } else {
          range.setStart(editor, 0);
          range.collapse(true);
        }
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (err) {
        // ignore
      }
      embed.remove();
      contentUpdateSourceRef.current = "programmatic";
      cursorRestoreRef.current = getCaretCharacterOffsetWithin(editor);
      handleContentChange({ target: { innerHTML: editor.innerHTML } }, { preserveCursor: true });
    }
  };

  // Import media from device: upload image/audio/video, embed at cursor as container
  const handleImportFiles = (e) => {
    const files = e.target.files;
    if (!files || !files.length || !editorRef.current) return;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const type = file.type || "";
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = String(reader.result || "");
        if (type.startsWith("image/")) {
          insertHTMLAtCursor(
            `<figure class="cc-embed cc-embed-image" contenteditable="false">${embedRemoveButton}<img src="${dataUrl}" alt="${file.name || ""}" /><figcaption contenteditable="true">Caption</figcaption></figure>`
          );
        } else if (type.startsWith("audio/")) {
          insertHTMLAtCursor(
            `<div class="cc-embed cc-embed-audio" contenteditable="false">${embedRemoveButton}<audio controls src="${dataUrl}">Your browser does not support audio.</audio></div>`
          );
        } else if (type.startsWith("video/")) {
          insertHTMLAtCursor(
            `<div class="cc-embed cc-embed-video" contenteditable="false">${embedRemoveButton}<video controls src="${dataUrl}" style="max-width:100%;height:auto;">Your browser does not support video.</video></div>`
          );
        }
      };
      reader.readAsDataURL(file);
    }
    e.target.value = "";
  };

  // Open embed bar; store cursor offset so Insert uses this position
  const openEmbedBar = (type) => {
    let cursorOffset = null;
    try {
      const editor = editorRef.current;
      const sel = window.getSelection();
      if (editor && sel.rangeCount && sel.anchorNode && editor.contains(sel.anchorNode)) {
        cursorOffset = getCaretCharacterOffsetWithin(editor);
      }
    } catch (e) {
      // ignore
    }
    setEmbedBar({ type, url: "", text: "", cursorOffset });
  };

  const closeEmbedBar = () => {
    setEmbedBar(null);
  };

  // Apply alignment to selected text/paragraph; works even when dropdown steals focus
  const handleAlignment = (align) => {
    const editor = editorRef.current;
    if (!editor) return;
    editor.focus();
    const value = { left: "left", center: "center", right: "right", justify: "justify" }[align];
    if (!value) return;
    // Try execCommand first (applies to current block)
    const cmd = { left: "justifyLeft", center: "justifyCenter", right: "justifyRight", justify: "justifyFull" }[align];
    document.execCommand(cmd, false, null);
    // Set text-align on block containing selection so alignment sticks
    try {
      const sel = window.getSelection();
      if (sel.rangeCount && sel.anchorNode && editor.contains(sel.anchorNode)) {
        let node = sel.getRangeAt(0).commonAncestorContainer;
        if (node.nodeType === Node.TEXT_NODE) node = node.parentNode;
        const block = node.closest ? node.closest("p, h1, h2, h3, h4, h5, h6, div") : null;
        if (block && block !== editor && editor.contains(block)) {
          block.style.textAlign = value;
        }
      }
    } catch (e) {
      // ignore
    }
    setAlignment(align);
    const ed = editorRef.current;
    if (ed) {
      contentUpdateSourceRef.current = "programmatic";
      cursorRestoreRef.current = getCaretCharacterOffsetWithin(ed);
      handleContentChange({ target: { innerHTML: ed.innerHTML } }, { preserveCursor: true });
    }
  };

  const insertEmbed = () => {
    if (!embedBar || !editorRef.current) return;
    const { type, url, text, cursorOffset } = embedBar;
    const trimmedUrl = (url || "").trim();
    if (!trimmedUrl && type !== "comment") return;

    const editor = editorRef.current;
    if (cursorOffset != null) {
      const len = editor.textContent?.length ?? 0;
      setCaretPosition(editor, Math.min(cursorOffset.start, len), Math.min(cursorOffset.end, len));
    }
    focusEditor();

    switch (type) {
      case "link":
        if (trimmedUrl) {
          const linkText = (text || trimmedUrl).trim() || trimmedUrl;
          insertHTMLAtCursor(
            `<div class="cc-embed cc-embed-link" contenteditable="false">${embedRemoveButton}<a href="${trimmedUrl}" target="_blank" rel="noopener noreferrer">${linkText}</a><span class="cc-embed-link-url">${trimmedUrl}</span></div>`
          );
        }
        break;
      case "image":
        insertHTMLAtCursor(
          `<figure class="cc-embed cc-embed-image" contenteditable="false">${embedRemoveButton}<img src="${trimmedUrl}" alt="" /><figcaption contenteditable="true">Caption</figcaption></figure>`
        );
        break;
      case "audio":
        insertHTMLAtCursor(
          `<div class="cc-embed cc-embed-audio" contenteditable="false">${embedRemoveButton}<audio controls src="${trimmedUrl}">Your browser does not support audio.</audio></div>`
        );
        break;
      case "video":
        insertHTMLAtCursor(
          `<div class="cc-embed cc-embed-video" contenteditable="false">${embedRemoveButton}<video controls src="${trimmedUrl}" style="max-width:100%;height:auto;">Your browser does not support video.</video></div>`
        );
        break;
            default:
        break;
    }
    closeEmbedBar();
  };

  // Style dropdown handler – applies to current selection/paragraph
  const handleStyleChange = (style) => {
    focusEditor();
    setSelectedStyle(style);
    switch(style) {
      case "Normal text":
        execCommand("formatBlock", "<p>");
        break;
      case "Heading 1":
        execCommand("formatBlock", "<h1>");
        break;
      case "Heading 2":
        execCommand("formatBlock", "<h2>");
        break;
      case "Heading 3":
        execCommand("formatBlock", "<h3>");
        break;
      case "Heading 4":
        execCommand("formatBlock", "<h4>");
        break;
      case "Heading 5":
        execCommand("formatBlock", "<h5>");
        break;
      case "Heading 6":
        execCommand("formatBlock", "<h6>");
        break;
      default:
        break;
    }
  };

  // Add tag functionality
  const addTag = () => {
    if (currentTag.trim() && !tags.includes(currentTag.trim())) {
      setTags([...tags, currentTag.trim()]);
      setCurrentTag("");
      checkForChanges();
    }
  };

  // Remove tag functionality
  const removeTag = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
    checkForChanges();
  };

  const loadDraft = async (draftId) => {
    try {
      const draft = await contentService.getContentById(draftId);
      if (draft) {
        const newTitle = draft.title || '';
        const newSubtitle = draft.subtitle || '';
        const newContent = draft.bodyHtml || '';
        const newTags = draft.tags || [];
        
        setTitle(newTitle);
        setSubtitle(newSubtitle);
        setContent(newContent);
        setPublishCategory(draft.category || '');
        setIsAnnouncement(draft.category === "Community Outreach Programs");
        setMinorEligible(draft.minorEligible || false);
        setTags(newTags);
        setSocialTitle(draft.socialTitle || '');
        setHasUnsavedChanges(false);
        setSocialDescription(draft.socialDescription || '');
        setSocialImageUrl(draft.socialImageUrl || '');
        setContentId(draft.id);
        
        setInitialContent({ title: newTitle, subtitle: newSubtitle, content: newContent, tags: newTags });
        setIsInitialLoad(false);
        setIsSaved(true);
        setView('add-content');
      }
    } catch (error) {
      console.error('Error loading draft:', error);
    }
  };

  const loadDraftData = (draft) => {
    try {
      const newTitle = draft.title || '';
      const newSubtitle = draft.subtitle || '';
      const newContent = draft.bodyHtml || '';
      const newTags = Array.isArray(draft.tags) ? draft.tags : [];
      
      setTitle(newTitle);
      setSubtitle(newSubtitle);
      setContent(newContent);
      setPublishCategory(draft.category || '');
      setIsAnnouncement(draft.category === "Community Outreach Programs");
      setMinorEligible(draft.minorEligible || false);
      setTags(newTags);
      setSocialTitle(draft.socialTitle || '');
      setSocialDescription(draft.socialDescription || '');
      setSocialImageUrl(draft.socialImageUrl || '');
      setContentId(draft.id || '');
      
      setInitialContent({ title: newTitle, subtitle: newSubtitle, content: newContent, tags: newTags });
      setIsInitialLoad(false);
      setIsSaved(true);
      setHasUnsavedChanges(false);
      setView('add-content');
    } catch (error) {
      console.error('Error loading draft data:', error);
    }
  };

  const clearAllFields = () => {
    const emptyContent = { title: '', subtitle: '', content: '', tags: [] };
    
    setTitle('');
    setSubtitle('');
    setContent('');
    setPublishCategory('');
    setMinorEligible(false);
    setTags([]);
    setCurrentTag('');
    setSelectedStyle('Normal text');
    setAlignment('left');
    setSocialTitle('');
    setSocialDescription('');
    setSocialImageUrl('');
    setContentId('');
    
    setInitialContent(emptyContent);
    setIsSaved(true);
    setHasUnsavedChanges(false);
    setIsInitialLoad(true);
    setHistory([]);
    setHistoryIndex(-1);
    setIsAnnouncement(false);
    setView('add-content');
  };

  // Handle showAddContent prop from ContentCurator
  useEffect(() => {
    if (showAddContent) {
      clearAllFields();
      if (isAnnouncementMode) {
        setIsAnnouncement(true);
        setPublishCategory("Community Outreach Programs");
      }
    } else {
      setView("dashboard");
    }
  }, [showAddContent, isAnnouncementMode]);

  // Initialize with empty content
  useEffect(() => {
    saveToHistory();
  }, []);

  // Create a draft when entering the editor (add-content)
  useEffect(() => {
    if (view !== "add-content") return;
    if (contentId) return;
    (async () => {
      try {
        await createDraftIfNeeded();
      } catch (e) {
        // ignore for now; editor can still be used offline
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view]);

  // Autosave draft (debounced) while editing
  useEffect(() => {
    if (view !== "add-content") return;
    if (!contentId) return;
    if (autosaveTimerRef.current) clearTimeout(autosaveTimerRef.current);
    autosaveTimerRef.current = setTimeout(() => {
      saveDraft().catch(() => {});
    }, 800);
    return () => {
      if (autosaveTimerRef.current) clearTimeout(autosaveTimerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, contentId, title, subtitle, content, publishCategory, socialTitle, socialDescription, socialImageUrl]);

  // Handle editingDraft prop changes
  useEffect(() => {
    if (editingDraft) {
      loadDraftData(editingDraft);
      setContentId(editingDraft.id);
      setView('add-content');
    }
  }, [editingDraft]);

  // Update editor DOM only when content changed programmatically (toolbar, embed, undo, redo).
  // When the user types we do NOT replace the editor DOM, so the cursor stays in place.
  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;
    
    const isProgrammatic = contentUpdateSourceRef.current === "programmatic";
    const pendingCursor = cursorRestoreRef.current;

    if (isProgrammatic) {
      editor.innerHTML = content || "Start writing...";
    } else if (content === "" && (!editor.innerHTML || editor.innerHTML === "Start writing..." || editor.innerHTML === "<br>")) {
      editor.innerHTML = "Start writing...";
    }

    // Restore cursor after React re-renders the contenteditable (fixes cursor stuck at start)
    if (isProgrammatic && pendingCursor != null) {
      cursorRestoreRef.current = null;
      const { start, end } = pendingCursor;
      const len = editor.textContent?.length ?? 0;
      requestAnimationFrame(() => {
        const el = editorRef.current;
        if (el && typeof el.nodeType === "number" && document.contains(el)) {
          setCaretPosition(el, Math.min(start, len), Math.min(end, len));
        }
      });
    }
    
    contentUpdateSourceRef.current = null;
  }, [content]);

  
  // Force LTR direction on editor focus and handle cursor properly
  useEffect(() => {
    const editor = editorRef.current;
    if (editor) {
      const handleFocus = () => {
        editor.style.direction = 'ltr';
        editor.style.unicodeBidi = 'embed';
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        const range = selection.getRangeAt(0);
        const startOffset = range.startOffset;
        const startContainer = range.startContainer;
        if (!startContainer || typeof startContainer.nodeType !== "number") return;

        setTimeout(() => {
          try {
            const newRange = document.createRange();
            if (startContainer.nodeType === Node.TEXT_NODE && document.contains(startContainer)) {
              newRange.setStart(startContainer, Math.min(startOffset, startContainer.length));
              newRange.collapse(true);
            } else if (document.contains(editor)) {
              newRange.selectNodeContents(editor);
              newRange.collapse(false);
            } else {
              return;
            }
            selection.removeAllRanges();
            selection.addRange(newRange);
          } catch (e) {
            try {
              if (document.contains(editor)) {
                const fallbackRange = document.createRange();
                fallbackRange.selectNodeContents(editor);
                fallbackRange.collapse(false);
                selection.removeAllRanges();
                selection.addRange(fallbackRange);
              }
            } catch (e2) {
              // ignore
            }
          }
        }, 0);
      };
      
      const handleInput = () => {
        editor.style.direction = 'ltr';
        editor.style.unicodeBidi = 'embed';
      };

      const handleKeyDown = (e) => {
        // Ensure cursor moves correctly with arrow keys
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Backspace' || e.key === 'Delete') {
          setTimeout(() => {
            editor.style.direction = 'ltr';
            editor.style.unicodeBidi = 'embed';
          }, 0);
        }
        
        // Handle Tab key for indentation
        if (e.key === 'Tab') {
          e.preventDefault();
          if (e.shiftKey) {
            // Decrease indent - use outdent command
            document.execCommand('outdent', false, null);
          } else {
            // Increase indent - insert 4 spaces
            document.execCommand('insertText', false, '      ');
          }
          contentUpdateSourceRef.current = "programmatic";
          cursorRestoreRef.current = getCaretCharacterOffsetWithin(editor);
          handleContentChange({ target: { innerHTML: editor.innerHTML } }, { preserveCursor: true });
        }
      };

      const handleMouseUp = () => {
        // Preserve cursor position after mouse selection
        setTimeout(() => {
          editor.style.direction = 'ltr';
          editor.style.unicodeBidi = 'embed';
        }, 0);
      };

      editor.addEventListener('focus', handleFocus);
      editor.addEventListener('input', handleInput);
      editor.addEventListener('keydown', handleKeyDown);
      editor.addEventListener('mouseup', handleMouseUp);
      
      return () => {
        editor.removeEventListener('focus', handleFocus);
        editor.removeEventListener('input', handleInput);
        editor.removeEventListener('keydown', handleKeyDown);
        editor.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, []);

  const renderAddContent = () => (
    <div className="cc-add-content-container">
      {/* Top Header Bar */}
      <header className="cc-top-header">
        <div className="cc-header-left">
          <button className="cc-back-btn" onClick={handleBackClick}>
            <FiArrowLeft />
          </button>
          <div className="cc-saved-status">
            <div className={`cc-status-dot ${isSaved ? 'saved' : 'unsaved'}`}></div>
            <span>{isSaving ? 'Saving...' : (isSaved ? 'Saved' : 'Unsaved')}</span>
          </div>
        </div>
        
        <div className="cc-header-right">
          <button
            className="cc-continue-btn"
            type="button"
            onClick={handleSaveDraft}
            disabled={isSaving || isSaved}
            style={{
              background: '#fff',
              border: '2px solid transparent',
              backgroundImage: 'linear-gradient(#fff, #fff), linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              color: '#3b82f6',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)',
              transition: 'all 0.2s ease',
              opacity: (isSaving || isSaved) ? 0.6 : 1
            }}
            onMouseEnter={(e) => {
              if (!isSaving && !isSaved) {
                e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
                e.target.style.color = '#fff';
              }
            }}
            onMouseLeave={(e) => {
              if (!isSaving && !isSaved) {
                e.target.style.background = '#fff';
                e.target.style.border = '2px solid transparent';
                e.target.style.backgroundImage = 'linear-gradient(#fff, #fff), linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
                e.target.style.backgroundOrigin = 'border-box';
                e.target.style.backgroundClip = 'padding-box, border-box';
                e.target.style.color = '#3b82f6';
              }
            }}
          >
            <FiSave /> {isSaving ? 'Saving...' : 'Save Changes'}
          </button>
          <button
            className="cc-preview-btn"
            type="button"
            onClick={() => {
              setPreviewDevice("desktop");
              setIsPreviewOpen(true);
            }}
            style={{
              background: '#fff',
              border: '2px solid transparent',
              backgroundImage: 'linear-gradient(#fff, #fff), linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              color: '#3b82f6',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
              e.target.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#fff';
              e.target.style.border = '2px solid transparent';
              e.target.style.backgroundImage = 'linear-gradient(#fff, #fff), linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
              e.target.style.backgroundOrigin = 'border-box';
              e.target.style.backgroundClip = 'padding-box, border-box';
              e.target.style.color = '#3b82f6';
            }}
          >
            Preview
          </button>
          <button
            className="cc-continue-btn"
            type="button"
            onClick={openPublishModal}
            style={{
              background: '#fff',
              border: '2px solid transparent',
              backgroundImage: 'linear-gradient(#fff, #fff), linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              color: '#3b82f6',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
              e.target.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#fff';
              e.target.style.border = '2px solid transparent';
              e.target.style.backgroundImage = 'linear-gradient(#fff, #fff), linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
              e.target.style.backgroundOrigin = 'border-box';
              e.target.style.backgroundClip = 'padding-box, border-box';
              e.target.style.color = '#3b82f6';
            }}
          >
            Publish
          </button>
        </div>
      </header>

      {/* Toolbar */}
      <div className="cc-toolbar-header">
        <div className="cc-history-buttons">
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={handleUndo} disabled={historyIndex <= 0} title="Undo">
            <FiRotateCcw />
          </button>
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={handleRedo} disabled={historyIndex >= history.length - 1} title="Redo">
            <FiRotateCw />
          </button>
        </div>
        
        <div className="cc-editor-toolbar">
          {/* Style Dropdown */}
          <div className="cc-dropdown">
            <button className="cc-dropdown-btn" onMouseDown={(e) => e.preventDefault()} title="Text style">
              {selectedStyle} <FiChevronDown size={12} />
            </button>
            <div className="cc-dropdown-menu">
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleStyleChange("Normal text")}>Normal text</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleStyleChange("Heading 1")}>Heading 1</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleStyleChange("Heading 2")}>Heading 2</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleStyleChange("Heading 3")}>Heading 3</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleStyleChange("Heading 4")}>Heading 4</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleStyleChange("Heading 5")}>Heading 5</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleStyleChange("Heading 6")}>Heading 6</div>
            </div>
          </div>
          
          <div className="cc-toolbar-divider"></div>
          
          {/* Text Formatting */}
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('bold')} title="Bold text">
            <FiBold />
          </button>
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('italic')} title="Italic text">
            <FiItalic />
          </button>
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('underline')} title="Underline text">
            <FiUnderline />
          </button>
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('strikeThrough')} title="Strikethrough text">
            <FiMinus />
          </button>
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('formatBlock', '<pre>')} title="Code block">
            <FiCode />
          </button>
          
          <div className="cc-toolbar-divider"></div>
          
          {/* Media and Links – open embed bar, insert in editor */}
          <button
            className="cc-tool-btn"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => openEmbedBar('link')}
            title="Insert link"
          >
            <FiLink />
          </button>
          <button
            className="cc-tool-btn"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => openEmbedBar('image')}
            title="Insert image"
          >
            <FiImage />
          </button>
          <button
            className="cc-tool-btn"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => openEmbedBar('audio')}
            title="Insert audio"
          >
            <FiVolume2 />
          </button>
          <button
            className="cc-tool-btn"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => openEmbedBar('video')}
            title="Insert video"
          >
            <FiVideo />
          </button>
                    <input
            ref={importFileInputRef}
            type="file"
            accept="image/*,audio/*,video/*"
            multiple
            className="cc-import-file-input"
            onChange={handleImportFiles}
            aria-label="Import image, audio, or video from device"
          />
          <button
            type="button"
            className="cc-tool-btn cc-import-btn"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => importFileInputRef.current?.click()}
            title="Import image, audio, or video from device"
          >
            <FiUpload /> Import
          </button>
          
          <div className="cc-toolbar-divider"></div>
          
          {/* Lists */}
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('insertUnorderedList')} title="Bullet list">
            <FiList />
          </button>
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('insertOrderedList')} title="Numbered list">
            <FiList style={{ transform: 'rotate(90deg)' }} />
          </button>
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('indent')} title="Indent">
            <FiAlignLeft />
          </button>
          <button className="cc-tool-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => execCommand('outdent')} title="Decrease indent">
            <FiAlignLeft style={{ transform: 'scaleX(-1)' }} />
          </button>
          
          <div className="cc-toolbar-divider"></div>
          
          {/* Alignment – mousedown preventDefault keeps editor selection when clicking option */}
          <div className="cc-dropdown">
            <button className="cc-dropdown-btn" title="Text alignment" onMouseDown={(e) => e.preventDefault()}>
              Align <FiChevronDown size={12} />
            </button>
            <div className="cc-dropdown-menu">
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleAlignment("left")}><FiAlignLeft /> Left</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleAlignment("center")}><FiAlignCenter /> Center</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleAlignment("right")}><FiAlignRight /> Right</div>
              <div onMouseDown={(e) => e.preventDefault()} onClick={() => handleAlignment("justify")}><FiAlignJustify /> Justify</div>
            </div>
          </div>
          
        </div>
      </div>

      {/* Live Preview Modal with System Branding */}
      {isPreviewOpen && (
        <Portal>
          <div className="cc-preview-overlay" style={{ background: 'rgba(15, 23, 42, 0.85)' }}>
            <div className="cc-preview-modal" style={{ borderRadius: '16px', overflow: 'hidden' }}>
              <header className="cc-preview-header" style={{
                background: 'linear-gradient(135deg, #1e3a8a 0%, #0f172a 100%)',
                color: '#fff',
                padding: '24px 32px'
              }}>
                <div>
                  <div className="cc-edit-social-title" style={{ color: '#fff' }}>Preview</div>
                  <div className="cc-edit-social-subtitle" style={{ color: '#cbd5e1' }}>
                    See how your content will appear on different devices
                  </div>
                </div>
                <button
                  type="button"
                  className="cc-edit-social-close"
                  onClick={() => setIsPreviewOpen(false)}
                  aria-label="Close preview"
                  title="Close"
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    color: '#fff',
                    borderRadius: '10px'
                  }}
                >
                  <FiX />
                </button>
              </header>

              <div style={{
                padding: '16px 32px',
                background: 'rgba(15, 23, 42, 0.5)',
                borderBottom: '1px solid rgba(255,255,255,0.1)'
              }}>
                <div className="cc-preview-tabs" style={{ display: 'flex', gap: '8px' }}>
                  <button
                    type="button"
                    className={previewDevice === "mobile" ? "active" : ""}
                    onClick={() => setPreviewDevice("mobile")}
                    style={{
                      color: '#fff',
                      background: previewDevice === "mobile" ? 'linear-gradient(135deg, #1e3a8a 0%, #0f172a 100%)' : 'transparent',
                      padding: '8px 16px',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    Mobile
                  </button>
                  <button
                    type="button"
                    className={previewDevice === "desktop" ? "active" : ""}
                    onClick={() => setPreviewDevice("desktop")}
                    style={{
                      color: '#fff',
                      background: previewDevice === "desktop" ? 'linear-gradient(135deg, #1e3a8a 0%, #0f172a 100%)' : 'transparent',
                      padding: '8px 16px',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    Desktop
                  </button>
                </div>
              </div>

              <div className="cc-preview-body">
                {previewDevice === "mobile" && (
                  <div className="cc-preview-mobile-frame">
                    <div className="cc-preview-mobile-notch" />
                    <div className="cc-preview-mobile-content">
                      <h1>{title || "Article Title"}</h1>
                      {subtitle && <h2>{subtitle}</h2>}
                      <div dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                  </div>
                )}
                {previewDevice === "desktop" && (
                  <div className="cc-preview-desktop-content">
                    <h1>{title || "Article Title"}</h1>
                    {subtitle && <h2>{subtitle}</h2>}
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Portal>
      )}

      {/* Publish Modal (Tags + Social preview) */}
      {isPublishOpen && (
        <div className="cc-publish-overlay" role="dialog" aria-modal="true">
          <div className="cc-publish-modal">
            <header className="cc-publish-header" style={{
              background: 'linear-gradient(135deg, #0f172a 0%, #3b82f6 100%)',
              padding: '24px 32px',
              textAlign: 'left'
            }}>
              <div style={{ textAlign: 'left' }}>
                <div className="cc-publish-title" style={{ color: '#fff', fontSize: '24px', fontWeight: '700' }}>Publish</div>
                <div className="cc-publish-subtitle" style={{ color: '#cbd5e1', fontSize: '16px', marginTop: '4px' }}>
                  Configure category and social preview before submitting for approval.
                </div>
              </div>
              <button
                type="button"
                className="cc-publish-close"
                onClick={closePublishModal}
                aria-label="Close publish modal"
                title="Close"
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  color: '#fff'
                }}
              >
                <FiX />
              </button>
            </header>

            <div className="cc-publish-content">
              <div className="cc-publish-section">
                <div className="cc-publish-label">{t.addResource}</div>
                <select
                  className="cc-publish-select"
                  value={publishCategory}
                  onChange={(e) => setPublishCategory(e.target.value)}
                >
                  <option value="">{t.selectCategory}</option>
                  {PUBLISH_CATEGORIES.filter((c) => 
                    isAnnouncement ? c === "Community Outreach Programs" : c !== "Community Outreach Programs"
                  ).map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>

              <div className="cc-publish-section">
                <div className="cc-publish-label">{t.contentSettings}</div>
                <div className="cc-publish-checkbox-wrapper">
                  <input
                    type="checkbox"
                    id="minor-eligible"
                    className="cc-publish-checkbox"
                    checked={minorEligible}
                    onChange={(e) => setMinorEligible(e.target.checked)}
                  />
                  <label htmlFor="minor-eligible" className="cc-publish-checkbox-label">
                    {t.minorEligible}
                  </label>
                </div>
              </div>

              <div className="cc-publish-section">
                <div className="cc-publish-label">{t.socialPreview}</div>
                <div className="cc-social-preview" style={{ position: 'relative' }}>
                  <button
                    type="button"
                    className="cc-publish-cancel"
                    onClick={openEditSocial}
                    style={{
                      position: 'absolute',
                      top: '12px',
                      right: '12px',
                      transition: 'all 0.2s ease',
                      zIndex: 10
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
                      e.target.style.color = '#fff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = '';
                      e.target.style.color = '';
                    }}
                  >
                    {t.editSocial}
                  </button>
                  <div className="cc-social-image">
                    {socialImageUrl ? (
                      <img src={socialImageUrl} alt="" />
                    ) : (
                      <div className="cc-social-image-placeholder">No image</div>
                    )}
                  </div>
                  <div className="cc-social-meta">
                    <div className="cc-social-title">
                      {(socialTitle || title || t.title).trim()}
                    </div>
                    <div className="cc-social-desc">
                      {(socialDescription || subtitle || t.description).trim()}
                    </div>
                    <div className="cc-social-domain">auravit</div>
                  </div>
                </div>
              </div>
            </div>

            <footer className="cc-publish-footer">
              <button
                type="button"
                className="cc-publish-cancel"
                onClick={closePublishModal}
                style={{
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#e2e8f0';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '';
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="cc-publish-cancel"
                onClick={submitForApproval}
                disabled={isSubmitting}
                style={{
                  transition: 'all 0.2s ease',
                  opacity: isSubmitting ? 0.6 : 1
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) {
                    e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
                    e.target.style.color = '#fff';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSubmitting) {
                    e.target.style.background = '';
                    e.target.style.color = '';
                  }
                }}
              >
                {isSubmitting ? 'Submitting...' : 'Submit for Approval'}
              </button>
            </footer>
          </div>

          {/* Edit social preview modal */}
          {isEditSocialOpen && (
            <div className="cc-edit-social-overlay" role="dialog" aria-modal="true">
              <div className="cc-edit-social-modal">
                <header className="cc-edit-social-header" style={{
                  background: 'linear-gradient(135deg, #0f172a 0%, #3b82f6 100%)'
                }}>
                  <div>
                    <div className="cc-edit-social-title" style={{ color: '#fff' }}>Edit social preview</div>
                    <div className="cc-edit-social-subtitle" style={{ color: '#cbd5e1' }}>
                      Change how this post appears on other platforms.
                    </div>
                  </div>
                  <button
                    type="button"
                    className="cc-edit-social-close"
                    onClick={closeEditSocial}
                    aria-label="Close edit social preview"
                    title="Close"
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      color: '#fff'
                    }}
                  >
                    <FiX />
                  </button>
                </header>

                <div className="cc-edit-social-body">
                  <label className="cc-edit-field">
                    <span>Title</span>
                    <input
                      type="text"
                      value={socialTitle}
                      onChange={(e) => setSocialTitle(e.target.value)}
                      placeholder="Title"
                    />
                  </label>

                  <label className="cc-edit-field">
                    <span>Description</span>
                    <textarea
                      value={socialDescription}
                      onChange={(e) => setSocialDescription(e.target.value)}
                      placeholder="Description"
                      rows={4}
                      maxLength={250}
                    />
                    <div className="cc-edit-count">
                      {socialDescription.length} / 250 (Recommended)
                    </div>
                  </label>

                  <div className="cc-edit-image-section">
                    <div className="cc-edit-image-label">Image</div>
                    <div
                      className="cc-edit-image-box"
                      role="button"
                      tabIndex={0}
                      onClick={() => socialImageInputRef.current?.click()}
                      onKeyDown={(e) =>
                        e.key === "Enter" && socialImageInputRef.current?.click()
                      }
                      title="Click to import image"
                      style={{
                        background: socialImageUrl ? '' : 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)'
                      }}
                    >
                      {socialImageUrl ? (
                        <>
                          <img src={socialImageUrl} alt="" />
                          <button
                            type="button"
                            className="cc-edit-image-remove"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSocialImageUrl("");
                            }}
                            aria-label="Remove image"
                            title="Remove image"
                          >
                            <FiX />
                          </button>
                        </>
                      ) : (
                        <div className="cc-edit-image-placeholder" style={{ color: '#fff' }}>
                          Click to import an image
                        </div>
                      )}
                      <input
                        ref={socialImageInputRef}
                        type="file"
                        accept="image/*"
                        className="cc-import-file-input"
                        onChange={handlePickSocialImage}
                      />
                    </div>
                  </div>
                </div>

                <footer className="cc-edit-social-footer">
                  <button
                    type="button"
                    className="cc-publish-cancel"
                    onClick={closeEditSocial}
                    style={{
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = '#e2e8f0';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = '';
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="cc-publish-cancel"
                    onClick={closeEditSocial}
                    style={{
                      transition: 'all 0.2s ease',
                      opacity: 1
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
                      e.target.style.color = '#fff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = '';
                      e.target.style.color = '';
                    }}
                  >
                    Save
                  </button>
                </footer>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Embed bar – sits below toolbar; disappears on Cancel, media inserts at saved cursor position */}
      {embedBar && (
        <div className="cc-embed-bar">
          {embedBar.type === "link" && (
            <>
              <input
                type="url"
                className="cc-embed-input"
                placeholder="URL"
                value={embedBar.url}
                onChange={(e) => setEmbedBar((b) => ({ ...b, url: e.target.value }))}
                onKeyDown={(e) => e.key === "Enter" && insertEmbed()}
              />
              <input
                type="text"
                className="cc-embed-input"
                placeholder="Link text (optional)"
                value={embedBar.text}
                onChange={(e) => setEmbedBar((b) => ({ ...b, text: e.target.value }))}
                onKeyDown={(e) => e.key === "Enter" && insertEmbed()}
              />
            </>
          )}
          {(embedBar.type === "image" || embedBar.type === "audio" || embedBar.type === "video") && (
            <input
              type="url"
              className="cc-embed-input cc-embed-input-wide"
              placeholder={`Enter ${embedBar.type} URL`}
              value={embedBar.url}
              onChange={(e) => setEmbedBar((b) => ({ ...b, url: e.target.value }))}
              onKeyDown={(e) => e.key === "Enter" && insertEmbed()}
            />
          )}
          {embedBar.type === "comment" && (
            <span className="cc-embed-hint">Click Insert to add a comment block in the content.</span>
          )}
          <div className="cc-embed-bar-actions">
            <button type="button" className="cc-btn cc-embed-insert" onClick={insertEmbed}>
              Insert
            </button>
            <button type="button" className="cc-btn cc-embed-cancel" onClick={closeEmbedBar}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Main Content Area */}
      <div className="cc-editor-content">
        
        <input
          type="text"
          className="cc-title"
          placeholder="Title"
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            checkForChanges();
          }}
          aria-label="Content title"
        />
        
        <input
          type="text"
          className="cc-subtitle"
          placeholder="Add a subtitle..."
          value={subtitle}
          onChange={(e) => {
            setSubtitle(e.target.value);
            checkForChanges();
          }}
          aria-label="Content subtitle"
        />
        
        <div className="cc-tags-container">
          {tags.map((tag, index) => (
            <div key={index} className="cc-tag">
              {tag}
              <button onClick={() => removeTag(tag)}>
                <FiX size={12} />
              </button>
            </div>
          ))}
        </div>
        
        <div
          ref={(el) => {
            editorRef.current = el;
            if (el && !el.innerHTML) {
              el.innerHTML = content === "" ? "Start writing..." : content;
            }
          }}
          className="cc-text-editor"
          contentEditable="true"
          suppressContentEditableWarning={true}
          onFocus={() => {
            if (content === "") {
              contentUpdateSourceRef.current = "programmatic";
              setContent("<br>");
            }
          }}
          onClick={handleEditorClick}
          onInput={handleContentChange}
          style={{ direction: 'ltr', unicodeBidi: 'embed' }}
        />
      </div>

      <div 
        className={`cc-character-counter ${characterCount >= 1400 ? 'warning' : characterCount >= 5000 ? 'error' : ''}`}
        style={{
          background: '#fff',
          border: '2px solid transparent',
          backgroundImage: 'linear-gradient(#fff, #fff), linear-gradient(135deg, #0f172a 0%, #3b82f6 100%)',
          backgroundOrigin: 'border-box',
          backgroundClip: 'padding-box, border-box',
          color: characterCount >= 5000 ? '#dc2626' : (characterCount >= 1400 ? '#d97706' : '#1e3a8a'),
          width: 'fit-content',
          maxWidth: '150px',
          padding: '8px 16px',
          fontSize: '14px',
          fontWeight: '600',
          position: 'absolute',
          bottom: '20px',
          right: '20px',
          borderRadius: '8px',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          marginLeft: 'auto'
        }}
      >
        {characterCount} / 5000 characters
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="cc-success-overlay" role="dialog" aria-modal="true">
          <div className="cc-success-modal">
            <header className="cc-success-header">
              <div className="cc-success-icon">
                <div className="cc-success-checkmark">✓</div>
              </div>
              <div className="cc-success-title">Submitted for Approval!</div>
            </header>
            
            <div className="cc-success-content">
              <p>Your content has been successfully submitted for approval.</p>
              <p>The admin team will review your submission and you'll be notified of the decision.</p>
            </div>

            <footer className="cc-success-footer">
              <button 
                type="button" 
                className="cc-success-btn"
                onClick={() => {
                  setShowSuccessModal(false);
                  setView("dashboard");
                }}
                style={{
                  background: '#f1f5f9',
                  color: '#475569',
                  borderRadius: '10px',
                  border: 'none',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)';
                  e.target.style.color = '#fff';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#f1f5f9';
                  e.target.style.color = '#475569';
                }}
              >
                Back to Dashboard
              </button>
            </footer>
          </div>
        </div>
      )}

      {/* Validation Modal */}
      {validationModal.show && (
        <div className="cc-success-overlay" role="dialog" aria-modal="true" onClick={() => setValidationModal({ show: false, message: "" })}>
          <div className="cc-success-modal" onClick={(e) => e.stopPropagation()}>
            <header className="cc-success-header" style={{ background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)' }}>
              <div className="cc-success-icon" style={{ background: 'rgba(255, 255, 255, 0.1)', border: '2px solid rgba(255, 255, 255, 0.3)' }}>
                <div className="cc-success-checkmark">✕</div>
              </div>
              <div className="cc-success-title">Validation Error</div>
            </header>

            <div className="cc-success-content">
              <p>{validationModal.message}</p>
            </div>

            <footer className="cc-success-footer">
              <button
                type="button"
                className="cc-success-btn"
                onClick={() => setValidationModal({ show: false, message: "" })}
              >
                OK
              </button>
            </footer>
          </div>
        </div>
      )}

      {/* Unsaved Changes Modal */}
      {showUnsavedModal && (
        <div className="cc-success-overlay" role="dialog" aria-modal="true" onClick={() => setShowUnsavedModal(false)}>
          <div className="cc-success-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px', width: '90%' }}>
            <header className="cc-success-header" style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #0f172a 100%)', padding: '24px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ textAlign: 'left' }}>
                <div className="cc-success-title" style={{ color: '#fff', fontSize: '24px', fontWeight: '700' }}>Leave or Continue Editing</div>
                <div className="cc-success-subtitle" style={{ color: '#cbd5e1', fontSize: '14px', marginTop: '4px' }}>
                  You have changes unsaved
                </div>
              </div>
              <button
                type="button"
                onClick={handleContinueEditing}
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  color: '#fff',
                  borderRadius: '10px',
                  border: 'none',
                  padding: '8px 12px'
                }}
              >
                <FiX />
              </button>
            </header>

            <div className="cc-success-content" style={{ padding: '32px', textAlign: 'left' }}>
              <p style={{ color: '#475569', fontSize: '16px', lineHeight: '1.6' }}>
                Your work will not be saved and will be deleted.
              </p>
            </div>

            <footer className="cc-success-footer" style={{ padding: '20px 32px', borderTop: '1px solid rgba(255,255,255,0.1)', display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                className="cc-success-btn"
                onClick={handleContinueEditing}
                style={{
                  background: '#f1f5f9',
                  color: '#475569',
                  borderRadius: '10px',
                  border: 'none',
                  padding: '10px 20px',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)';
                  e.target.style.color = '#fff';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#f1f5f9';
                  e.target.style.color = '#475569';
                }}
              >
                Continue Editing
              </button>
              <button
                type="button"
                className="cc-success-btn"
                onClick={handleSaveAndLeave}
                disabled={isSaving}
                style={{
                  background: '#f1f5f9',
                  color: '#475569',
                  borderRadius: '10px',
                  border: 'none',
                  padding: '10px 20px',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease',
                  opacity: isSaving ? 0.6 : 1
                }}
                onMouseEnter={(e) => {
                  if (!isSaving) {
                    e.target.style.background = 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)';
                    e.target.style.color = '#fff';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSaving) {
                    e.target.style.background = '#f1f5f9';
                    e.target.style.color = '#475569';
                  }
                }}
              >
                {isSaving ? 'Saving...' : 'Save Changes'}
              </button>
              <button
                type="button"
                className="cc-success-btn"
                onClick={handleLeaveUnsaved}
                style={{
                  background: '#f1f5f9',
                  color: '#475569',
                  borderRadius: '10px',
                  border: 'none',
                  padding: '10px 20px',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)';
                  e.target.style.color = '#fff';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#f1f5f9';
                  e.target.style.color = '#475569';
                }}
              >
                Leave
              </button>
            </footer>
          </div>
        </div>
      )}
    </div>
  );

  const renderPublishEvent = () => (
    <div className="cc-add-content-container">
      {/* Header */}
      <header className="cc-add-header">
        <h2>Publish Announcements & Events</h2>
      </header>

      <div className="cc-add-grid">
        {/* Left Column: Announcement & Event Details */}
        <div className="cc-details-panel">
          <h3>Announcement & Event Details</h3>
          <div className="cc-form-box">
            <div className="cc-form-group">
              <label>Title</label>
              <input type="text" placeholder="Enter Announcement/Event Title" className="cc-input" />
            </div>

            <div className="cc-form-group">
              <label>Description</label>
              <div className="cc-rich-editor">
                 <div className="cc-mini-toolbar">
                    <button className="cc-mini-tool-btn"><FiBold /></button>
                    <button className="cc-mini-tool-btn"><FiItalic /></button>
                    <button className="cc-mini-tool-btn"><FiUnderline /></button>
                    <button className="cc-mini-tool-btn"><FiType /></button>
                    <div className="cc-divider"></div>
                    <button className="cc-mini-tool-btn">H1 <FiMoreHorizontal size={10} /></button>
                    <div className="cc-divider"></div>
                    <button className="cc-mini-tool-btn"><FiList /> List</button>
                    <button className="cc-mini-tool-btn">1. List</button>
                    <div className="cc-divider"></div>
                    <button className="cc-mini-tool-btn"><FiAlignLeft /></button>
                 </div>
                 <textarea placeholder="Write the full details of the announcement/event here....." className="cc-textarea-no-border" style={{ direction: 'ltr', unicodeBidi: 'embed' }}></textarea>
              </div>
            </div>

            <div className="cc-form-group">
               <select className="cc-select">
                  <option>Type</option>
                  <option>Announcement</option>
                  <option>Event</option>
               </select>
            </div>
             <div className="cc-form-group">
               <select className="cc-select">
                  <option>Target Audience</option>
                  <option>Staff</option>
                  <option>Students</option>
               </select>
            </div>
          </div>
        </div>

        {/* Right Column: Attachment & Schedule */}
        <div className="cc-preview-panel">
          
           {/* Attachment */}
           <div className="cc-form-section-blue no-margin-top">
              <div className="cc-form-header">Attachment</div>
              <div className="cc-form-body">
                 <div className="cc-drop-zone">
                    <FiPackage size={48} color="#999" />
                    <p>Drop Files to Upload<br/>or <em>Browse</em></p>
                 </div>
              </div>
           </div>

           {/* Schedule & Visibility */}
           <div className="cc-form-section-blue">
              <div className="cc-form-header">Schedule & Visibility</div>
              <div className="cc-form-body">
                 <div className="cc-date-picker-wrapper">
                   <input type="text" placeholder="Publish Date & Time" className="cc-input" />
                   <FiCalendar className="cc-date-icon" />
                 </div>
                 <div className="cc-date-picker-wrapper">
                   <input type="text" placeholder="Expiration Date" className="cc-input" />
                   <FiCalendar className="cc-date-icon" />
                 </div>
              </div>
           </div>

           {/* Status */}
           <div className="cc-form-section-blue">
              <div className="cc-form-header">Status</div>
              <div className="cc-form-body">
                 <div className="cc-radio-row">
                    <label className="cc-radio">
                      <input type="radio" name="event-status" /> Draft
                    </label>
                    <label className="cc-radio">
                      <input type="radio" name="event-status" /> Published
                    </label>
                 </div>
              </div>
           </div>

        </div>
      </div>

      {/* Footer Actions */}
      <div className="cc-footer-actions">
        <button className="cc-btn-primary">Publish</button>
        <button className="cc-btn-secondary">Draft</button>
        <button className="cc-btn-secondary" onClick={() => setView("dashboard")}>Cancel</button>
      </div>
    </div>
  );

  return (
    <div className="cc-dashboard">
      {view === "dashboard" && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <h1 className="pd-welcome">Welcome Back, {currentUserFirstName || "Content Curator"}!</h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
              <button className="cc-action-btn" style={{ flex: '0 0 auto', width: 'auto', minWidth: 0 }} onClick={() => {
                clearAllFields();
              }}>
                <FiPlus /> Publish New Content
              </button>
              <button className="cc-action-btn" style={{ flex: '0 0 auto', width: 'auto', minWidth: 0 }} onClick={() => {
                clearAllFields();
                setIsAnnouncement(true);
                setPublishCategory("Community Outreach Programs");
              }}>
                <FiEdit /> Create Announcement
              </button>
            </div>
          </div>

          {/* Engagement Trends & Status Overview */}
          <section style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "24px" }}>
            {/* Engagement Trends - Left */}
            <div className="cc-analytics">
              <header className="cc-section-header">Engagement Trends</header>
              {(() => {
                // Format date as "Jun 05"
                const formatDate = (dateStr) => {
                  const date = new Date(dateStr);
                  return date.toLocaleDateString("en-US", { month: "short", day: "2-digit" });
                };

                // Format tooltip date as "Jun 05, 2026"
                const formatTooltipDate = (dateStr) => {
                  const date = new Date(dateStr);
                  return date.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
                };

                const chartData = dailyStats.map((item) => ({
                  name: formatDate(item.date),
                  fullDate: item.date,
                  views: item.views || 0,
                  bookmarks: item.bookmarks || 0,
                  shares: item.shares || 0,
                }));

                const CustomTooltip = ({ active, payload, label }) => {
                  if (active && payload && payload.length) {
                    return (
                      <div className="custom-tooltip" style={{ backgroundColor: "white", padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}>
                        <p className="label" style={{ margin: 0, marginBottom: "5px" }}>{formatTooltipDate(payload[0].payload.fullDate)}</p>
                        {payload.map((entry, index) => (
                          <p key={index} style={{ margin: 0, color: entry.color }}>
                            {entry.name}: {entry.value}
                          </p>
                        ))}
                      </div>
                    );
                  }
                  return null;
                };

                return (
                  <div className="cc-chart-container">
                    {loadingDailyStats ? (
                      <div className="skeleton-chart">
                        <div className="skeleton skeleton-header"></div>
                        <div className="skeleton skeleton-subheader"></div>
                        <div className="skeleton skeleton-content"></div>
                      </div>
                    ) : (
                      <>
                        <ResponsiveContainer width="100%" height={240}>
                          <LineChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                            <CartesianGrid stroke="#e0e7ff" strokeDasharray="3 3" />
                            <XAxis dataKey="name" tick={{ fill: "#1e40af" }} />
                            <YAxis tick={{ fill: "#1e40af" }} />
                            <Tooltip content={<CustomTooltip />} />
                            <Line type="monotone" dataKey="views" name="Views" stroke="#3b82f6" strokeWidth={3} dot={{ r: 4, fill: "#3b82f6" }} />
                            <Line type="monotone" dataKey="bookmarks" name="Bookmarks" stroke="#10b981" strokeWidth={3} dot={{ r: 4, fill: "#10b981" }} />
                            <Line type="monotone" dataKey="shares" name="Shares" stroke="#f59e0b" strokeWidth={3} dot={{ r: 4, fill: "#f59e0b" }} />
                          </LineChart>
                        </ResponsiveContainer>
                        {/* Legend */}
                        <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "15px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <div style={{ width: "12px", height: "12px", backgroundColor: "#3b82f6" }}></div>
                            <span style={{ color: "#1e40af" }}>Views</span>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <div style={{ width: "12px", height: "12px", backgroundColor: "#10b981" }}></div>
                            <span style={{ color: "#1e40af" }}>Bookmarks</span>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <div style={{ width: "12px", height: "12px", backgroundColor: "#f59e0b" }}></div>
                            <span style={{ color: "#1e40af" }}>Shares</span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                );
              })()}
            </div>

            {/* Status Overview - Right */}
            <div className="cc-analytics">
              <header className="cc-section-header">Status Overview</header>
              <div className="cc-chart-container">
                {loadingAnalytics ? (
                  <div className="skeleton-chart">
                    <div className="skeleton skeleton-header"></div>
                    <div className="skeleton skeleton-subheader"></div>
                    <div className="skeleton-bars-vertical">
                      {[1, 2, 3, 4, 5, 6].map((index) => (
                        <div 
                          key={index} 
                          className="skeleton skeleton-bar-vertical" 
                          style={{ height: `${200 - (index * 25)}px`, width: '60px' }}
                        ></div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <ResponsiveContainer width="100%" height={240}>
                    <BarChart
                      data={[
                        {
                          name: "Content",
                          Draft: analyticsData.content.draft,
                          Pending: analyticsData.content.pending,
                          Published: analyticsData.content.published,
                        },
                        {
                          name: "Announcements",
                          Draft: analyticsData.announcements.draft,
                          Pending: analyticsData.announcements.pending,
                          Published: analyticsData.announcements.published,
                        },
                      ]}
                      margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                      <CartesianGrid stroke="#e0e7ff" strokeDasharray="3 3" />
                      <XAxis dataKey="name" tick={{ fill: "#1e40af" }} />
                      <YAxis tick={{ fill: "#1e40af" }} allowDecimals={false} />
                      <Tooltip />
                      <Bar dataKey="Draft" name="Draft" fill="#93c5fd" />
                      <Bar dataKey="Pending" name="Pending" fill="#3b82f6" />
                      <Bar dataKey="Published" name="Published" fill="#1e40af" />
                    </BarChart>
                  </ResponsiveContainer>
                )}
                {/* Legend */}
                <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "15px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <div style={{ width: "12px", height: "12px", backgroundColor: "#93c5fd" }}></div>
                    <span style={{ color: "#1e40af" }}>Draft</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <div style={{ width: "12px", height: "12px", backgroundColor: "#3b82f6" }}></div>
                    <span style={{ color: "#1e40af" }}>Pending</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <div style={{ width: "12px", height: "12px", backgroundColor: "#1e40af" }}></div>
                    <span style={{ color: "#1e40af" }}>Published</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          
          {/* Two Column Layout */}
          <div className="cc-two-columns" style={{ display: "flex", gap: "24px" }}>
            {/* Left Column */}
            <div className="cc-column" style={{ flex: 1 }}>
              {/* Content Performance */}
              <section className="cc-section" style={{ height: "100%" }}>
                <header className="cc-section-header">Content Performance</header>
                {loadingTopPerforming ? (
                  <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "12px", height: "calc(100% - 56px)" }}>
                    {[1, 2, 3].map((index) => (
                      <div key={index} style={{ padding: "12px", borderRadius: "8px", background: "#f3f4f6", display: "flex", gap: "12px" }}>
                        <div className="skeleton" style={{ width: "80px", height: "80px", borderRadius: "4px" }}></div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px", flexGrow: 1 }}>
                          <div className="skeleton skeleton-header"></div>
                          <div className="skeleton skeleton-subheader"></div>
                          <div style={{ display: "flex", gap: "24px" }}>
                            <div className="skeleton" style={{ width: "50px", height: "16px" }}></div>
                            <div className="skeleton" style={{ width: "50px", height: "16px" }}></div>
                            <div className="skeleton" style={{ width: "50px", height: "16px" }}></div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    {topPerformingContent.length > 0 ? (
                      <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "12px", height: "calc(100% - 56px)" }}>
                        {topPerformingContent.map(content => (
                          <div
                            key={content.id}
                            style={{
                              padding: "12px",
                              borderRadius: "8px",
                              background: "#f3f4f6",
                              display: "flex",
                              gap: "12px",
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              // Use approvalId if available, otherwise we need to get it via contentId
                              // But for now, let's first use approvalId, if not present, we can check if we can get it
                              navigate(`/article-view?id=${content.approvalId || content.id}&from=library`);
                            }}
                          >
                            {/* Social Image */}
                            <div style={{ width: "80px", height: "80px", flexShrink: 0 }}>
                              {content.socialImageUrl ? (
                                <img
                                  src={content.socialImageUrl}
                                  alt={content.title}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "4px"
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.nextSibling.style.display = "flex";
                                  }}
                                />
                              ) : null}
                              <div
                                style={{
                                  display: content.socialImageUrl ? "none" : "flex",
                                  width: "100%",
                                  height: "100%",
                                  background: "#e5e7eb",
                                  borderRadius: "4px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#9ca3af"
                                }}
                              >
                                No Image
                              </div>
                            </div>

                            {/* Title & Engagement Counts */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", flexGrow: 1, justifyContent: "center" }}>
                              <h4
                                style={{
                                  margin: 0,
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  color: "#1e40af",
                                  textAlign: "left"
                                }}
                              >
                                {content.title}
                              </h4>
                              <div style={{ fontSize: "13px", color: "#6b7280", textAlign: "left" }}>
                                Published Date: {formatPostDate(content.publishedAt || content.approvedAt)}
                              </div>
                              {/* Engagement Counts Row */}
                              <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "4px", color: "#6b7280" }}>
                                  <FiView size={16} />
                                  <span style={{ fontSize: "14px" }}>{content.views}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "4px", color: "#6b7280" }}>
                                  <FiBookmark size={16} />
                                  <span style={{ fontSize: "14px" }}>{content.bookmarks}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "4px", color: "#6b7280" }}>
                                  <FiShare2 size={16} />
                                  <span style={{ fontSize: "14px" }}>{content.shares}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ padding: "32px", textAlign: "center", color: "#6b7280" }}>
                        No content yet.
                      </div>
                    )}
                  </>
                )}
              </section>
            </div>

            {/* Right Column */}
            <div className="cc-column" style={{ flex: 1 }}>
              {/* Audience Insights */}
              <section className="cc-section" style={{ height: "100%" }}>
                <header className="cc-section-header">Audience Insights</header>
                {loadingAudienceInsights ? (
                  <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "32px", height: "calc(100% - 56px)" }}>
                    <div>
                      <div className="skeleton skeleton-header"></div>
                      <div className="skeleton skeleton-subheader" style={{ height: "60px", marginTop: "8px" }}></div>
                    </div>
                    <div>
                      <div className="skeleton skeleton-header"></div>
                      {[1, 2, 3].map((index) => (
                        <div key={index} className="skeleton" style={{ height: "40px", marginTop: "10px", borderRadius: "6px" }}></div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "32px", height: "calc(100% - 56px)" }}>
                    {/* Most Viewed Category */}
                    {mostViewedCategory && (
                      <div>
                        <div style={{ fontSize: "16px", fontWeight: "500", color: "#374151", marginBottom: "8px" }}>Most Viewed Topic</div>
                        <div style={{ 
                          fontSize: "20px", 
                          fontWeight: "600", 
                          color: "#ffffff",
                          background: "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
                          padding: "16px",
                          borderRadius: "8px",
                          textAlign: "center"
                        }}>
                          {mostViewedCategory}
                        </div>
                      </div>
                    )}
                    {/* Top Engagement Categories */}
                    {topEngagementCategories.length > 0 && (
                      <div>
                        <div style={{ fontSize: "16px", fontWeight: "500", color: "#374151", marginBottom: "12px" }}>Popular Categories</div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                          {topEngagementCategories.map((item, index) => {
                            let gradient;
                            if (index === 0) {
                              gradient = "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)";
                            } else if (index === 1) {
                              gradient = "linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)";
                            } else {
                              gradient = "linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%)";
                            }
                            
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  padding: "12px 16px",
                                  background: gradient,
                                  borderRadius: "6px"
                                }}
                              >
                                <span style={{ fontSize: "15px", fontWeight: "500", color: "#ffffff" }}>
                                  {item.category}
                                </span>
                                <span style={{ fontSize: "15px", fontWeight: "500", color: "#ffffff" }}>
                                  {item.total}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </section>
            </div>
          </div>

          {/* Analytics & Content Overview Row */}
          <section style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "24px" }}>
            {/* Latest Post */}
            <div className="cc-analytics">
              <header className="cc-section-header">Latest Post</header>
              {loadingLatestPost ? (
                <div style={{ padding: "16px" }}>
                  <div style={{ display: "flex", gap: "12px" }}>
                    <div className="skeleton" style={{ width: "80px", height: "80px", borderRadius: "8px" }}></div>
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px" }}>
                      <div className="skeleton skeleton-header"></div>
                      <div className="skeleton skeleton-subheader"></div>
                      <div style={{ display: "flex", gap: "20px", marginTop: "8px" }}>
                        <div className="skeleton" style={{ height: "40px", borderRadius: "10px" }}></div>
                        <div className="skeleton" style={{ height: "40px", borderRadius: "10px" }}></div>
                        <div className="skeleton" style={{ height: "40px", borderRadius: "10px" }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {latestPost ? (
                <div style={{ padding: "16px" }}>
                  {/* Post Content */}
                  <div style={{ display: "flex", gap: "12px" }}>
                    {/* Cover Photo */}
                    <div style={{ flexShrink: 0, width: "80px", height: "80px", borderRadius: "8px", overflow: "hidden" }}>
                      <img
                        src={latestPost.socialImageUrl || "https://via.placeholder.com/80x80"}
                        alt={latestPost.title}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </div>
                    {/* Title & Date */}
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px", textAlign: "left" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <h4
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#1e40af",
                            cursor: "pointer",
                            textAlign: "left"
                          }}
                          onClick={() => navigate(`/article-view?id=${latestPost.contentId || latestPost.id}`)}
                        >
                          {latestPost.title || "Untitled"}
                        </h4>
                        <div style={{ position: "relative" }} className="latest-post-dropdown-container" ref={optionsDropdownRef}>
                          <button
                            onClick={() => setIsOptionsDropdownOpen(!isOptionsDropdownOpen)}
                            style={{
                              background: "none",
                              border: "none",
                              padding: "8px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            <FiMoreVertical size={24} style={{ color: "#6b7280" }} />
                          </button>
                          {isOptionsDropdownOpen && (
                            <div style={{
                              position: "absolute",
                              top: "100%",
                              right: 0,
                              background: "white",
                              borderRadius: "8px",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                              zIndex: 100,
                              minWidth: "140px",
                              overflow: "hidden"
                            }}>
                              <button
                                onClick={handleCopyLatestPostLink}
                                style={{
                                  width: "100%",
                                  padding: "10px 16px",
                                  textAlign: "left",
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  color: "#374151",
                                  transition: "background 0.15s ease",
                                  ":hover": { background: "#f3f4f6" }
                                }}
                                onMouseEnter={(e) => e.target.style.background = "#f3f4f6"}
                                onMouseLeave={(e) => e.target.style.background = "transparent"}
                              >
                                Copy Link
                              </button>
                              <button
                                onClick={() => {
                                  if (latestPostRevision?.status !== "pending") {
                                    navigate(`/curator-revise/${latestPost.contentId || latestPost.id}`);
                                    setIsOptionsDropdownOpen(false);
                                  }
                                }}
                                disabled={latestPostRevision?.status === "pending"}
                                style={{
                                  width: "100%",
                                  padding: "10px 16px",
                                  textAlign: "left",
                                  background: "none",
                                  border: "none",
                                  cursor: latestPostRevision?.status === "pending" ? "not-allowed" : "pointer",
                                  fontSize: "14px",
                                  color: latestPostRevision?.status === "pending" ? "#9ca3af" : "#374151",
                                  transition: "background 0.15s ease"
                                }}
                                onMouseEnter={(e) => { if (latestPostRevision?.status !== "pending") e.target.style.background = "#f3f4f6"; }}
                                onMouseLeave={(e) => e.target.style.background = "transparent"}
                              >
                                {latestPostRevision?.status === "pending" ? "Revision Pending" : "Revise"}
                              </button>
                              <button
                                onClick={() => {
                                  navigate(`/article-view?id=${latestPost.contentId || latestPost.id}`);
                                  setIsOptionsDropdownOpen(false);
                                }}
                                style={{
                                  width: "100%",
                                  padding: "10px 16px",
                                  textAlign: "left",
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  color: "#374151",
                                  transition: "background 0.15s ease"
                                }}
                                onMouseEnter={(e) => e.target.style.background = "#f3f4f6"}
                                onMouseLeave={(e) => e.target.style.background = "transparent"}
                              >
                                View
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{ fontSize: "14px", color: "#6b7280", textAlign: "left" }}>
                        {formatPostDate(latestPost.publishedAt || latestPost.approvedAt)}
                      </div>
                    </div>
                  </div>
                  {/* Engagement Metrics */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "16px", marginBottom: "16px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 16px", background: "linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%)", borderRadius: "10px", color: "#ffffff" }}>
                      <span style={{ fontWeight: "500" }}>Views</span>
                      <span style={{ fontWeight: "600" }}>{latestPost.stats?.views || 0}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 16px", background: "linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%)", borderRadius: "10px", color: "#ffffff" }}>
                      <span style={{ fontWeight: "500" }}>Bookmarks</span>
                      <span style={{ fontWeight: "600" }}>{latestPost.stats?.bookmarks || 0}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 16px", background: "linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%)", borderRadius: "10px", color: "#ffffff" }}>
                      <span style={{ fontWeight: "500" }}>Shares</span>
                      <span style={{ fontWeight: "600" }}>{latestPost.stats?.shares || 0}</span>
                    </div>
                  </div>
                  {/* Share Button */}
                  <button
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      border: "none",
                      background: "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
                      color: "#ffffff",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px"
                    }}
                    onClick={handleShare}
                  >
                    <RiShare2Line size={16} />
                    Share Post
                  </button>
                </div>
              ) : (
                <div style={{ padding: "32px", textAlign: "center", color: "#6b7280" }}>
                  No published content available.
                </div>
              )}
                </>
              )}
            </div>

            {/* Drafts */}
            <div className="cc-analytics">
              <header className="cc-section-header">Drafts</header>
              {loadingDrafts ? (
                <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
                  {[1, 2, 3].map((index) => (
                    <div key={index} style={{ padding: "12px", borderRadius: "8px", background: "#f3f4f6", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                      <div style={{ textAlign: "left" }}>
                        <div className="skeleton skeleton-header"></div>
                        <div className="skeleton skeleton-subheader"></div>
                      </div>
                      <div className="skeleton" style={{ width: "32px", height: "32px", borderRadius: "4px" }}></div>
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  {drafts.length > 0 ? (
                    <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
                      {drafts.map(draft => (
                        <div
                          key={draft.id}
                          style={{
                            padding: "12px",
                            borderRadius: "8px",
                            background: "#f3f4f6",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            cursor: "pointer"
                          }}
                          onClick={() => onEditDraft && onEditDraft(draft)}
                        >
                          <div style={{ textAlign: "left" }}>
                            <h4
                              style={{
                                margin: 0,
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "#1e40af",
                                textAlign: "left"
                              }}
                            >
                              {draft.title}
                            </h4>
                            <div style={{ marginTop: "4px" }}>
                              <span style={{ fontSize: "13px", color: "#6b7280" }}>
                                Last modified: {formatDraftDate(draft.lastModified || draft.updatedAt)}
                              </span>
                            </div>
                          </div>
                          <div style={{ position: "relative" }} className="draft-dropdown-container">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenDraftDropdownId(openDraftDropdownId === draft.id ? null : draft.id);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                padding: "8px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              <FiMoreVertical size={24} style={{ color: "#6b7280" }} />
                            </button>
                            {openDraftDropdownId === draft.id && (
                              <div style={{
                                position: "absolute",
                                top: "100%",
                                right: 0,
                                background: "white",
                                borderRadius: "8px",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                zIndex: 100,
                                minWidth: "140px",
                                overflow: "hidden"
                              }}>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onEditDraft && onEditDraft(draft);
                                    setOpenDraftDropdownId(null);
                                  }}
                                  style={{
                                    width: "100%",
                                    padding: "10px 16px",
                                    textAlign: "left",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    color: "#374151",
                                    transition: "background 0.15s ease"
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = "#f3f4f6"}
                                  onMouseLeave={(e) => e.target.style.background = "transparent"}
                                >
                                  Edit
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setDraftToDelete(draft);
                                    setDeleteDraftModal(true);
                                    setOpenDraftDropdownId(null);
                                  }}
                                  style={{
                                    width: "100%",
                                    padding: "10px 16px",
                                    textAlign: "left",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    color: "#dc2626",
                                    transition: "background 0.15s ease"
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = "#f3f4f6"}
                                  onMouseLeave={(e) => e.target.style.background = "transparent"}
                                >
                                  Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ padding: "32px", textAlign: "center", color: "#6b7280" }}>
                      No drafts available.
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Pending Approvals */}
            <div className="cc-analytics">
              <header className="cc-section-header">Pending Approvals</header>
              {loadingPendingApprovals ? (
                <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
                  {[1, 2, 3].map((index) => (
                    <div key={index} style={{ padding: "12px", borderRadius: "8px", background: "#f3f4f6", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px" }}>
                      <div className="skeleton" style={{ width: "60px", height: "60px", borderRadius: "4px" }}></div>
                      <div style={{ textAlign: "left", flexGrow: 1 }}>
                        <div className="skeleton skeleton-header"></div>
                        <div className="skeleton skeleton-subheader"></div>
                      </div>
                      <div className="skeleton" style={{ width: "32px", height: "32px", borderRadius: "4px" }}></div>
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  {pendingApprovals.length > 0 ? (
                    <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
                      {pendingApprovals.map(pending => (
                        <div
                          key={pending.id}
                          style={{
                            padding: "12px",
                            borderRadius: "8px",
                            background: "#f3f4f6",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            gap: "12px"
                          }}
                        >
                          {/* Social Image */}
                          <div style={{ width: "60px", height: "60px", flexShrink: 0 }}>
                            {pending.socialImageUrl ? (
                              <img
                                src={pending.socialImageUrl}
                                alt={pending.title}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  borderRadius: "4px"
                                }}
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div
                              style={{
                                display: pending.socialImageUrl ? "none" : "flex",
                                width: "100%",
                                height: "100%",
                                background: "#e5e7eb",
                                borderRadius: "4px",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#9ca3af"
                              }}
                            >
                              No Image
                            </div>
                          </div>

                          <div style={{ textAlign: "left", flexGrow: 1 }}>
                            <h4
                              style={{
                                margin: 0,
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "#1e40af",
                                cursor: "pointer",
                                textAlign: "left"
                              }}
                              onClick={() => navigate(`/article-view?id=${pending.id}`)}
                            >
                              {pending.title}
                            </h4>
                            <div style={{ marginTop: "4px" }}>
                              <span style={{ fontSize: "13px", color: "#6b7280" }}>
                                Submitted: {formatDraftDate(pending.submittedAt)}
                              </span>
                            </div>
                          </div>

                          <div style={{ position: "relative" }} className="pending-dropdown-container">
                            <button
                              onClick={() => setOpenPendingDropdownId(openPendingDropdownId === pending.id ? null : pending.id)}
                              style={{
                                background: "none",
                                border: "none",
                                padding: "8px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              <FiMoreVertical size={24} style={{ color: "#6b7280" }} />
                            </button>
                            {openPendingDropdownId === pending.id && (
                              <div style={{
                                position: "absolute",
                                top: "100%",
                                right: 0,
                                background: "white",
                                borderRadius: "8px",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                zIndex: 100,
                                minWidth: "140px",
                                overflow: "hidden"
                              }}>
                                <button
                                  onClick={() => {
                                    navigate(`/article-view?id=${pending.id}`);
                                    setOpenPendingDropdownId(null);
                                  }}
                                  style={{
                                    width: "100%",
                                    padding: "10px 16px",
                                    textAlign: "left",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    color: "#374151",
                                    transition: "background 0.15s ease"
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = "#f3f4f6"}
                                  onMouseLeave={(e) => e.target.style.background = "transparent"}
                                >
                                  View
                                </button>
                                <button
                                  onClick={() => {
                                    navigate(`/curator-revise/${pending.contentId || pending.id}`);
                                    setOpenPendingDropdownId(null);
                                  }}
                                  style={{
                                    width: "100%",
                                    padding: "10px 16px",
                                    textAlign: "left",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    color: "#374151",
                                    transition: "background 0.15s ease"
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = "#f3f4f6"}
                                  onMouseLeave={(e) => e.target.style.background = "transparent"}
                                >
                                  Revise
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ padding: "32px", textAlign: "center", color: "#6b7280" }}>
                      No pending approvals.
                    </div>
                  )}
                </>
              )}
            </div>
          </section>

        </>
      )}
      
      {view === "add-content" && renderAddContent()}
      {view === "publish-event" && renderPublishEvent()}

      {/* Copied Banner */}
      {showCopiedBanner && (
        <div style={{
          position: "fixed",
          top: "24px",
          right: "24px",
          background: "#10b981",
          color: "white",
          padding: "12px 24px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          zIndex: 1001,
          fontSize: "14px",
          fontWeight: "500"
        }}>
          Copied link!
        </div>
      )}

      {/* Delete Draft Confirmation Modal */}
      {deleteDraftModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000
        }} onClick={() => {
          setDeleteDraftModal(false);
          setDraftToDelete(null);
        }}>
          <div style={{
            background: "white",
            borderRadius: "12px",
            padding: "24px",
            maxWidth: "400px",
            width: "90%",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
            textAlign: "left"
          }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ fontSize: "20px", fontWeight: "600", margin: "0 0 16px 0", color: "#2c3e50" }}>
              Delete Draft?
            </h3>
            <p style={{ fontSize: "14px", color: "#6b7280", margin: "0 0 24px 0", lineHeight: "1.4" }}>
              Are you sure you want to delete the draft "{draftToDelete?.title || "Untitled"}"? This action cannot be undone.
            </p>
            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
              <button
                onClick={() => {
                  setDeleteDraftModal(false);
                  setDraftToDelete(null);
                }}
                style={{
                  padding: "10px 20px",
                  border: "1px solid #e5e7eb",
                  background: "white",
                  color: "#374151",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "background 0.2s ease"
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteDraft}
                style={{
                  padding: "10px 20px",
                  border: "none",
                  background: "#dc2626",
                  color: "white",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "background 0.2s ease"
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Share Modal */}
      {shareModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000
        }} onClick={handleCloseShareModal}>
          <div style={{
            background: "white",
            borderRadius: "12px",
            padding: "24px",
            maxWidth: "500px",
            width: "90%",
            maxHeight: "90vh",
            overflowY: "auto",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
            textAlign: "left"
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}>
              <h3 style={{ fontSize: "20px", fontWeight: "600", margin: 0, color: "#2c3e50" }}>Share Article</h3>
              <button onClick={handleCloseShareModal} style={{
                background: "none",
                border: "none",
                fontSize: "24px",
                color: "#6b7280",
                cursor: "pointer",
                padding: "8px",
                borderRadius: "8px",
                transition: "all 0.3s ease"
              }}>
                <FiX />
              </button>
            </div>

            {/* Content Preview */}
            <div style={{ marginBottom: "20px", padding: "16px", background: "#f8f9fa", borderRadius: "8px" }}>
              <h4 style={{ fontSize: "16px", fontWeight: "600", margin: "0 0 8px 0", color: "#2c3e50" }}>
                {latestPost?.title}
              </h4>
              <p style={{ fontSize: "14px", color: "#6c757d", margin: 0, lineHeight: "1.4" }}>
                {latestPost?.socialDescription || latestPost?.subtitle || stripHtmlToText(latestPost?.bodyHtml || "").substring(0, 100)}...
              </p>
            </div>

            {/* Social Share Buttons */}
            <div style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              marginBottom: "20px"
            }}>
              <button onClick={() => handleSocialShare("facebook")} style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                border: "none",
                background: "#1877f2",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s ease"
              }} title="Share on Facebook">
                <FaFacebook />
              </button>
              <button onClick={() => handleSocialShare("twitter")} style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                border: "none",
                background: "#1da1f2",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s ease"
              }} title="Share on Twitter">
                <FaXTwitter />
              </button>
              <button onClick={() => handleSocialShare("whatsapp")} style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                border: "none",
                background: "#25d366",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s ease"
              }} title="Share on WhatsApp">
                <FaWhatsapp />
              </button>
              <button onClick={() => handleSocialShare("telegram")} style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                border: "none",
                background: "#0088cc",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s ease"
              }} title="Share on Telegram">
                <FaTelegram />
              </button>
            </div>

            {/* Share URL Section */}
            <div>
              <label style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "500",
                marginBottom: "8px",
                color: "#2c3e50"
              }}>Article URL:</label>
              <div style={{ display: "flex", gap: "8px" }}>
                <input
                  type="text"
                  value={getArticleUrl()}
                  readOnly
                  style={{
                    flex: 1,
                    padding: "10px 12px",
                    border: "1px solid #dee2e6",
                    borderRadius: "6px",
                    fontSize: "14px",
                    background: "#f8f9fa"
                  }}
                />
                <button
                  onClick={handleCopyLink}
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    background: copyButtonText === "Copied!" ? "#28a745" : "#4a90e2",
                    color: "white",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "background 0.2s ease"
                  }}
                >
                  {copyButtonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentDashboard;
